<template>
  <div>
    <!-- 表格公用组件 -->
    <!-- true显示，false不显示 -->
    <div class="handerBox" v-if="distributionIsShow && isShowAllBtn">
      <el-button-group class="comTopRight">
        <el-tooltip
          class="item"
          effect="dark"
          content="点击刷新列表"
          placement="top-start"
        >
          <el-button @click="refreshTable">
            <i class="el-icon-refresh-right"></i> 刷新
          </el-button>
        </el-tooltip>
        <el-tooltip
          v-if="!isEstimateScore"
          class="item"
          effect="dark"
          content="点击导出当前列表数据(Excel格式)"
          placement="top-start"
        >
          <el-button @click="downloadExcelMes">
            <i class="el-icon-download"></i> 导出
          </el-button>
        </el-tooltip>
        <!-- //将所有列展示在此，可以点击进行隐藏与显示 -->
        <el-popover
          popper-class="handerPopoClass"
          placement="bottom"
          width="280"
          trigger="click"
        >
          <div class="trends_btn_wrap">
            <el-checkbox-group v-model="visibleList" :min="1" @change="visibleListChange">
              <el-checkbox
                v-for="(col, i) in columnList"
                :key="i"
                :label="col.label"
                :title="col.value"
                border
              >
                {{ col.value }}
              </el-checkbox>
            </el-checkbox-group>
          </div>
          <el-button slot="reference"> <i class="el-icon-setting"></i> 设置 </el-button>
        </el-popover>
      </el-button-group>
    </div>
    <div class="handerBox float-r" v-if="isShowDown && isShowAllBtn">
      <el-tooltip
        class="item"
        effect="dark"
        content="点击导出当前列表数据(Excel格式)"
        placement="top-start"
      >
        <el-button @click="downloadExcelMes">
          <i class="el-icon-download"></i> 导出
        </el-button>
      </el-tooltip>
    </div>
    <div
      class="floating-buttons"
      style="top: 159px"
      ref="configStateBar"
      @mousedown.prevent="handleMouseDown"
      v-if="!distributionIsShow && isShowAllBtn"
    >
      <el-tooltip class="item" effect="dark" content="点击刷新列表" placement="left-end">
        <el-button class="icon-box icon1" @click="refreshTable">
          <i class="el-icon-refresh-right icon"> 刷新</i>
        </el-button>
      </el-tooltip>
      <el-tooltip
        class="item"
        effect="dark"
        content="点击导出当前列表数据(Excel格式)"
        placement="left-end"
      >
        <el-button class="icon-box icon2" @click="downloadExcelMes">
          <i class="el-icon-download icon"> 导出</i>
        </el-button>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" content="设置" placement="left-end">
        <el-popover
          popper-class="handerPopoClass"
          placement="bottom"
          width="280"
          trigger="click"
        >
          <div>
            <el-checkbox-group v-model="visibleList" :min="1" @change="visibleListChange">
              <el-checkbox
                v-for="(col, index) in columnList"
                :key="index"
                :label="col.label"
                :title="col.value"
                border
                >{{ col.value }}</el-checkbox
              >
            </el-checkbox-group>
          </div>
          <el-button class="icon-box icon3" slot="reference">
            <i class="el-icon-setting"> 设置</i>
          </el-button>
        </el-popover>
      </el-tooltip>
      <el-button class="icon-box box1 icon4">点击拖动</el-button>
      <div class="tooltip" v-show="tooltipVisible">{{ tooltipText }}</div>
    </div>
    <div class="table_box" ref="tableContainer">
      <el-table
        ref="multipleTable"
        :cell-style="cellStyle"
        :row-key="rowKey"
        :class="checkboxAll ? '' : 'tableTemplate'"
        :data="tableData"
        tooltip-effect="dark mytoolTips"
        style="width: 100%; margin-top: 10px"
        border
        :empty-text="emptyText"
        :element-loading-text="loadingText"
        :table-height="tableMaxHeight"
        :height="tableHeight ? tableHeight : tableMaxHeight ? tableMaxHeight : null"
        @select="handleSelectionChange"
        @selection-change="handleSelectionChange1"
        @sort-change="sortTable"
        @select-all="handleSelectionChangeAll"
        :default-sort="{ prop: 'date', order: 'descending' }"
        stripe
        v-loading="tableLoading"
        :header-cell-style="{ background: '#f5f7fa', color: '#606266' }"
        :span-method="objectSpanMethod"
        :key="tableKey"
        id="elTableId"
      >
        <template v-for="(headerItem, headerIndex) in headerData">
          <template v-if="!curHideList[headerIndex]">
            <!-- ① 下拉框选择器 -->
            <el-table-column
              v-if="headerItem.selectSearch"
              :label="headerItem.label"
              :prop="headerItem.prop"
              :type="headerItem.type"
              :align="headerItem.align"
              :key="'info8-' + headerIndex"
              :width="headerItem.width"
              :fixed="fixedShow ? headerItem.fixed : false"
              :show-overflow-tooltip="headerItem.noTooltip"
            >
              <template slot="header" slot-scope="scope">
                <el-tooltip
                  effect="dark"
                  placement="bottom"
                  class="item"
                  popper-class="mt35"
                  :disabled="!headerItem.tipContent"
                >
                  <div class="content-h" slot="content" v-html="headerItem.content"></div>
                  <template v-if="headerItem.slotTitle">
                    <slot :name="headerItem.prop + 'Title'"></slot>
                  </template>
                  <template v-else>
                    <el-popover
                      v-if="headerItem.multiple"
                      placement="bottom"
                      width="220"
                      trigger="click"
                      :ref="'popover' + headerIndex"
                    >
                      <div slot="reference" class="search-header">
                        <span class="search-title">{{ headerItem.label }}</span>
                        &nbsp;
                        <i class="search-icon el-icon-search pointer"></i>
                        <i v-if="headerItem.tipContent" class="el-icon-question"></i>
                      </div>
                      <!-- 多选 -->
                      <el-select
                        v-model="headerItem[headerItem.prop]"
                        :placeholder="headerItem.label"
                        multiple
                        collapse-tags
                        :filterable="headerItem.selectOptions.length > 9 ? true : false"
                        :remote = "headerItem.remoteMethod ? true : false"
                        :filter-method="searchRemote(headerItem)"
                        @focus="searchRemote(headerItem)('')"
                        @change="
                          handleSearch(headerIndex, {
                            name: 'option',
                            prop: headerItem.prop,
                            value: headerItem[headerItem.prop],
                            source: headerItem.selectOptions,
                            row: scope.row,
                            type: 'selectAll',
                          })
                        "
                      >
                        <el-checkbox
                          class="right checkbox"
                          v-model="checked"
                          @change="selectAll(headerItem.prop, headerIndex)"
                          >全选
                        </el-checkbox>
                        <el-option
                          v-for="item in headerItem.selectOptions"
                          :key="item.key ? item.key : item.id"
                          :label="
                            item.label
                              ? item.label
                              : item.name
                              ? item.name
                              : item.value
                              ? item.value
                              : item.Value
                          "
                          :value="item.key ? item.key : item.id"
                        ></el-option>
                      </el-select>
                    </el-popover>

                    <!-- 非多选 -->
                    <div v-else class="search-header">
                      <el-select
                        v-model="headerItem[headerItem.prop]"
                        :placeholder="headerItem.label"
                        :clearable="headerItem.clearable"
                        :filterable="headerItem.selectOptions.length > 9 ? true : false"
                        :remote = "headerItem.remoteMethod ? true : false"
                        :filter-method="searchRemote(headerItem)"
                        @focus="searchRemote(headerItem)('')"
                        @change="
                          handleSearch(headerIndex, {
                            name: 'option',
                            prop: headerItem.prop,
                            value: headerItem[headerItem.prop],
                            source: headerItem.selectOptions,
                            row: scope.row,
                            type: 'select',
                          })
                        "
                        @clear="
                          handleSearch(headerIndex, {
                            name: 'option',
                            prop: headerItem.prop,
                            value: headerItem[headerItem.prop],
                            source: headerItem.selectOptions,
                            row: scope.row,
                            type: 'select',
                          })
                        "
                      >
                        <el-option
                          v-for="item in headerItem.selectOptions"
                          :key="item.key ? item.key : item.id"
                          :label="
                            item.label ? item.label : item.name ? item.name : item.value
                          "
                          :value="item.key ? item.key : item.id"
                        ></el-option>
                      </el-select>
                      <i v-if="headerItem.tipContent" class="el-icon-question"></i>
                    </div>
                  </template>
                </el-tooltip>
              </template>
              <!-- 表格的 内容 slot -->
              <template slot-scope="scope">
                <!-- 添加图片 -->
                <slot
                  v-if="
                    (scope.row[headerItem.imgPath] != 0 ||
                      scope.row[headerItem.imgPath] != null ||
                      scope.row[headerItem.imgPath] != '') &&
                    headerItem.selectImg
                  "
                  :scope="scope.row"
                  name="titleImg"
                ></slot>
                <!-- 没数据提示 -->
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="headerItem.content"
                  placement="right-start"
                  v-if="
                    (scope.row[headerItem.prop] == 0 ||
                      scope.row[headerItem.prop] == null ||
                      scope.row[headerItem.prop] == '') &&
                    headerItem.tooltip
                  "
                >
                  <span class="gray">{{ headerItem.noSetText }}</span>
                </el-tooltip>
                <!-- 没数据，不提示 -->
                <span
                  class="gray"
                  v-else-if="
                    (scope.row[headerItem.prop] == 0 ||
                      scope.row[headerItem.prop] == null ||
                      scope.row[headerItem.prop] == '' ||
                      scope.row[headerItem.prop] == headerItem.noSetText ||
                      scope.row[headerItem.prop] == '请选择') &&
                    headerItem.noTooltip
                  "
                  >{{ headerItem.noSetText }}</span
                >
                <!-- 设置字体颜色 -->
                <span
                  :style="{
                    color:
                      scope.row[headerItem.prop] == headerItem.rowText
                        ? headerItem.color
                        : '',
                  }"
                  v-else-if="
                    (scope.row[headerItem.prop] != 0 ||
                      scope.row[headerItem.prop] != null ||
                      scope.row[headerItem.prop] != '') &&
                    headerItem.isColor
                  "
                  >{{ scope.row[headerItem.prop] }}</span
                >
                <!-- 有数据，提示 -->
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="headerItem.content"
                  placement="right-start"
                  v-else-if="
                    (scope.row[headerItem.prop] != 0 ||
                      scope.row[headerItem.prop] != null ||
                      scope.row[headerItem.prop] != '') &&
                    headerItem.tooltip
                  "
                >
                  <span
                    :style="{
                      color:
                        scope.row[headerItem.prop] == headerItem.rowText
                          ? headerItem.color
                          : '',
                    }"
                    >{{ scope.row[headerItem.prop] }}</span
                  >
                </el-tooltip>
                <!-- 通过id下拉框显示对应的值 -->
                <span
                  :class="{
                    gray:
                      textIds(
                        scope.row[headerItem.prop],
                        headerItem.selectOptions,
                        'search'
                      ) === '未设置',
                  }"
                  v-else-if="headerItem.textIds"
                >
                  {{
                    textIds(
                      scope.row[headerItem.prop],
                      headerItem.selectOptions,
                      "search"
                    )
                  }}
                </span>
                <!-- 点击弹窗 -->
                <span
                  style="width: 100%"
                  class="text-overflow hand blue"
                  :style="{
                    'text-align': headerItem.align ? headerItem.align : 'left',
                  }"
                  v-else-if="headerItem.table"
                  @click="handleCard(scope.row, headerItem.prop)"
                  type="text"
                >
                  {{ scope.row[headerItem.prop] }}
                </span>
                <!-- 点击新窗口打开 -->
                <a
                  v-else-if="headerItem.linkUrl"
                  :href="headerItem.linkUrl + scope.row.id"
                  target="_blank"
                  title="点击新窗口跳转"
                  >&nbsp;{{ scope.row[headerItem.prop] }}</a
                >
                <!-- 点击弹窗 -->
                <span
                  class="pointer"
                  @click="clickText(scope.row, headerItem.prop)"
                  v-else-if="headerItem.clickText"
                >
                  {{ scope.row[headerItem.prop] }}
                </span>
                <!-- 自定义插槽 -->
                <slot
                  v-else-if="headerItem.custom"
                  :name="headerItem.prop + 'custom'"
                  :scope="scope.row"
                  :index="scope.$index"
                ></slot>
                <!-- 默认 -->
                <span v-else>{{ scope.row[headerItem.prop] }}</span>
                <slot
                  v-if="headerItem.endCustom"
                  :name="headerItem.prop + 'EndCustom'"
                  :scope="scope.row"
                  :index="scope.$index"
                ></slot>
              </template>
            </el-table-column>
            <!-- 输入框 -->
            <el-table-column
              v-else-if="headerItem.inputSearch"
              :label="headerItem.label"
              :prop="headerItem.prop"
              :type="headerItem.type"
              :align="headerItem.align"
              :key="'info7-' + headerIndex"
              :width="headerItem.width"
              :fixed="fixedShow ? headerItem.fixed : false"
              :show-overflow-tooltip="
                headerItem.noTooltip === undefined
                  ? true
                  : headerItem.noTooltip === true
                  ? true
                  : false
              "
            >
              <template slot="header" slot-scope="scope">
                <el-tooltip
                  effect="dark"
                  placement="bottom"
                  class="item"
                  popper-class="mt35"
                  :disabled="!headerItem.tipContent"
                >
                  <div class="content-h" slot="content" v-html="headerItem.content"></div>
                  <div class="searchbar">
                    <el-input
                      class="left width-input"
                      v-model="headerItem[headerItem.prop]"
                      :placeholder="headerItem.label"
                      clearable
                      @clear="
                        handleSearch(headerIndex, {
                          name: 'input',
                          prop: headerItem.prop,
                          value: headerItem[headerItem.prop],
                          row: scope,
                          type: 'text',
                        })
                      "
                    >
                      <i
                        slot="suffix"
                        class="el-input__icon searchbar-btn search-icon el-icon-search pointer"
                        @click="
                          handleSearch(headerIndex, {
                            name: 'input',
                            prop: headerItem.prop,
                            value: headerItem[headerItem.prop],
                            row: scope,
                            type: 'text',
                          })
                        "
                      ></i>
                    </el-input>
                    <i v-if="headerItem.tipContent" class="el-icon-question"></i>
                  </div>
                </el-tooltip>
              </template>
              <!-- 表格的 内容 slot -->
              <template slot-scope="scope">
                <slot
                  v-if="headerItem.inputSlot"
                  :scope="scope.row"
                  :name="headerItem.prop"
                ></slot>
                <!-- 没数据提示 -->
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="headerItem.content"
                  placement="right-start"
                  v-if="
                    (scope.row[headerItem.prop] == 0 ||
                      scope.row[headerItem.prop] == null ||
                      scope.row[headerItem.prop] == '') &&
                    headerItem.tooltip
                  "
                >
                  <span class="gray">{{ headerItem.noSetText }}</span>
                </el-tooltip>
                <!-- 没数据，不提示 -->
                <span
                  class="gray"
                  v-else-if="
                    (scope.row[headerItem.prop] == 0 ||
                      scope.row[headerItem.prop] == null ||
                      scope.row[headerItem.prop] == '' ||
                      scope.row[headerItem.prop] == headerItem.noSetText ||
                      scope.row[headerItem.prop] == '请选择') &&
                    headerItem.noTooltip
                  "
                  >{{ headerItem.noSetText }}</span
                >
                <!-- 无数据，可点击 -->
                <span
                  class="hover-sty"
                  @click="handleCard(scope.row, headerItem.prop)"
                  type="text"
                  v-else-if="
                    (scope.row[headerItem.prop] == 0 ||
                      scope.row[headerItem.prop] == null ||
                      scope.row[headerItem.prop] == '' ||
                      scope.row[headerItem.prop] == headerItem.noSetText ||
                      scope.row[headerItem.prop] == '请选择') &&
                    headerItem.clickData
                  "
                  >{{ headerItem.noSetText }}</span
                >
                <!-- 设置特定字体颜色 -->
                <span
                  :style="{
                    color:
                      scope.row[headerItem.prop] == headerItem.rowText
                        ? headerItem.color
                        : '',
                  }"
                  v-else-if="
                    (scope.row[headerItem.prop] != 0 ||
                      scope.row[headerItem.prop] != null ||
                      scope.row[headerItem.prop] != '') &&
                    headerItem.isColor
                  "
                  >{{ scope.row[headerItem.prop] }}</span
                >
                <!-- 有数据，提示 -->
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="headerItem.content"
                  placement="right-start"
                  v-else-if="
                    (scope.row[headerItem.prop] != 0 ||
                      scope.row[headerItem.prop] != null ||
                      scope.row[headerItem.prop] != '') &&
                    headerItem.tooltip
                  "
                >
                  <span
                    :style="{
                      color:
                        scope.row[headerItem.prop] == headerItem.rowText
                          ? headerItem.color
                          : '',
                    }"
                    >{{ scope.row[headerItem.prop] }}</span
                  >
                </el-tooltip>
                <!-- 通过id下拉框显示对应的值 -->
                <span
                  :class="{
                    gray:
                      textIds(
                        scope.row[headerItem.prop],
                        headerItem.selectOptions,
                        'input'
                      ) === '未设置',
                  }"
                  v-else-if="headerItem.textIds"
                >
                  {{
                    textIds(scope.row[headerItem.prop], headerItem.selectOptions, "input")
                  }}
                </span>
                <!-- 点击弹窗 -->
                <span
                  v-else-if="headerItem.table"
                  class="text-overflow hand blue"
                  :style="{
                    'text-align': headerItem.align ? headerItem.align : 'left',
                  }"
                  @click="handleCard(scope.row, headerItem.prop)"
                  type="text"
                  >{{ scope.row[headerItem.prop] }}</span
                >
                <!-- 点击新窗口打开 -->
                <a
                  v-else-if="headerItem.linkUrl"
                  :href="headerItem.linkUrl + scope.row.id"
                  target="_blank"
                  title="点击新窗口跳转"
                  >&nbsp;{{ scope.row[headerItem.prop] }}</a
                >
                <!-- 点击弹窗 -->
                <span
                  class="pointer blue"
                  @click="clickText(scope.row, headerItem.prop)"
                  v-else-if="headerItem.clickText"
                  >{{ scope.row[headerItem.prop] }}</span
                >
                <!-- 自定义插槽 -->
                <slot
                  v-else-if="headerItem.custom"
                  :name="headerItem.prop + 'custom'"
                  :scope="scope.row"
                  :index="scope.$index"
                ></slot>
                <!-- 默认 -->
                <span v-else>{{ scope.row[headerItem.prop] }}</span>
              </template>
            </el-table-column>
            <!-- 数字输入框 -->
            <el-table-column
              v-else-if="headerItem.inputSearchNumber"
              :label="headerItem.label"
              :prop="headerItem.prop"
              :type="headerItem.type"
              :align="headerItem.align"
              :key="'info7-' + headerIndex"
              :width="headerItem.width"
              :fixed="fixedShow ? headerItem.fixed : false"
              :show-overflow-tooltip="
                headerItem.noTooltip === undefined
                  ? true
                  : headerItem.noTooltip === true
                  ? true
                  : false
              "
            >
              <template slot="header" slot-scope="scope">
                <div class="searchbar">
                  <el-input
                    class="left width-input"
                    type="number"
                    v-model="headerItem[headerItem.prop]"
                    :placeholder="headerItem.label"
                    clearable
                    @clear="
                      handleSearch(headerIndex, {
                        name: 'input',
                        prop: headerItem.prop,
                        value: headerItem[headerItem.prop],
                        row: scope,
                        type: 'text',
                      })
                    "
                  >
                    <i
                      slot="suffix"
                      class="el-input__icon searchbar-btn search-icon el-icon-search pointer"
                      @click="
                        handleSearch(headerIndex, {
                          name: 'input',
                          prop: headerItem.prop,
                          value: headerItem[headerItem.prop],
                          row: scope,
                          type: 'text',
                        })
                      "
                    ></i>
                  </el-input>
                  <i v-if="headerItem.tipContent" class="el-icon-question"></i>
                </div>
              </template>
              <!-- 表格的 内容 slot -->
              <template slot-scope="scope">
                <slot
                  v-if="headerItem.inputSlot"
                  :scope="scope.row"
                  :name="headerItem.prop"
                ></slot>
                <!-- 没数据提示 -->
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="headerItem.content"
                  placement="right-start"
                  v-if="
                    (scope.row[headerItem.prop] == 0 ||
                      scope.row[headerItem.prop] == null ||
                      scope.row[headerItem.prop] == '') &&
                    headerItem.tooltip
                  "
                >
                  <span class="gray">{{ headerItem.noSetText }}</span>
                </el-tooltip>
                <!-- 没数据，不提示 -->
                <span
                  class="gray"
                  v-else-if="
                    (scope.row[headerItem.prop] == 0 ||
                      scope.row[headerItem.prop] == null ||
                      scope.row[headerItem.prop] == '' ||
                      scope.row[headerItem.prop] == headerItem.noSetText ||
                      scope.row[headerItem.prop] == '请选择') &&
                    headerItem.noTooltip
                  "
                  >{{ headerItem.noSetText }}</span
                >
                <!-- 无数据，可点击 -->
                <span
                  class="hover-sty"
                  @click="handleCard(scope.row, headerItem.prop)"
                  type="text"
                  v-else-if="
                    (scope.row[headerItem.prop] == 0 ||
                      scope.row[headerItem.prop] == null ||
                      scope.row[headerItem.prop] == '' ||
                      scope.row[headerItem.prop] == headerItem.noSetText ||
                      scope.row[headerItem.prop] == '请选择') &&
                    headerItem.clickData
                  "
                  >{{ headerItem.noSetText }}</span
                >
                <!-- 设置特定字体颜色 -->
                <span
                  :style="{
                    color:
                      scope.row[headerItem.prop] == headerItem.rowText
                        ? headerItem.color
                        : '',
                  }"
                  v-else-if="
                    (scope.row[headerItem.prop] != 0 ||
                      scope.row[headerItem.prop] != null ||
                      scope.row[headerItem.prop] != '') &&
                    headerItem.isColor
                  "
                  >{{ scope.row[headerItem.prop] }}</span
                >
                <!-- 有数据，提示 -->
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="headerItem.content"
                  placement="right-start"
                  v-else-if="
                    (scope.row[headerItem.prop] != 0 ||
                      scope.row[headerItem.prop] != null ||
                      scope.row[headerItem.prop] != '') &&
                    headerItem.tooltip
                  "
                >
                  <span
                    :style="{
                      color:
                        scope.row[headerItem.prop] == headerItem.rowText
                          ? headerItem.color
                          : '',
                    }"
                    >{{ scope.row[headerItem.prop] }}</span
                  >
                </el-tooltip>
                <!-- 通过id下拉框显示对应的值 -->
                <span
                  :class="{
                    gray:
                      textIds(
                        scope.row[headerItem.prop],
                        headerItem.selectOptions,
                        'input'
                      ) === '未设置',
                  }"
                  v-else-if="headerItem.textIds"
                >
                  {{
                    textIds(scope.row[headerItem.prop], headerItem.selectOptions, "input")
                  }}
                </span>
                <!-- 点击弹窗 -->
                <span
                  v-else-if="headerItem.table"
                  class="text-overflow hand blue"
                  :style="{
                    'text-align': headerItem.align ? headerItem.align : 'left',
                  }"
                  @click="handleCard(scope.row, headerItem.prop)"
                  type="text"
                  >{{ scope.row[headerItem.prop] }}</span
                >
                <!-- 点击新窗口打开 -->
                <a
                  v-else-if="headerItem.linkUrl"
                  :href="headerItem.linkUrl + scope.row.id"
                  target="_blank"
                  title="点击新窗口跳转"
                  >&nbsp;{{ scope.row[headerItem.prop] }}</a
                >
                <!-- 点击弹窗 -->
                <span
                  class="pointer blue"
                  @click="clickText(scope.row, headerItem.prop)"
                  v-else-if="headerItem.clickText"
                  >{{ scope.row[headerItem.prop] }}</span
                >
                <!-- 自定义插槽 -->
                <slot
                  v-else-if="headerItem.custom"
                  :name="headerItem.prop + 'custom'"
                  :scope="scope.row"
                  :index="scope.$index"
                ></slot>
                <!-- 默认 -->
                <span v-else>{{ scope.row[headerItem.prop] }}</span>
              </template>
            </el-table-column>
            <!-- 日期选择器分开 -->
            <!-- 使用日期组件 dateSearch参数必须为true-->
            <el-table-column
              v-else-if="headerItem.dateSearch"
              :label="headerItem.label"
              :prop="headerItem.prop"
              :type="headerItem.type"
              :align="headerItem.align"
              :key="'inf6-' + headerIndex"
              :fixed="fixedShow ? headerItem.fixed : false"
              :width="headerItem.width"
              :show-overflow-tooltip="true"
            >
              <template slot="header" slot-scope="scope">
                <el-tooltip
                  effect="dark"
                  placement="bottom"
                  class="item"
                  popper-class="mt35"
                  :disabled="!headerItem.tipContent"
                >
                  <div class="content-h" slot="content" v-html="headerItem.content"></div>
                  <!-- 默认 -->
                  <!-- 绑定数据为prop的值（防止多列数据重复） -->
                  <div
                    class="searchbar allocation_width"
                    v-if="
                      headerItem.Datetype &&
                      !headerItem.StartAndEnd &&
                      !headerItem.daterange
                    "
                  >
                    <el-date-picker
                      class="allocation-right left width160"
                      :type="headerItem.Datetype"
                      :placeholder="
                        headerItem.placeholder
                          ? headerItem.placeholder
                          : `选择${headerItem.label}`
                      "
                      v-model="headerItem[headerItem.prop]"
                      clearable
                      @change="
                        handleSearch(headerIndex, {
                          name: 'default',
                          prop: headerItem.prop,
                          value: headerItem[headerItem.prop],
                          row: scope.row,
                          type: 'time',
                        })
                      "
                    ></el-date-picker>
                    <i v-if="headerItem.tipContent" class="el-icon-question"></i>
                    <span
                      class="searchbar-btn box-icon"
                      v-if="!headerItem.isShowSearch"
                      @click="
                        handleSearch(headerIndex, {
                          name: 'default',
                          prop: headerItem.prop,
                          value: headerItem[headerItem.prop],
                          row: scope.row,
                          type: 'time',
                        })
                      "
                    >
                      <i class="search-icon el-icon-search pointer"></i>
                      
                    </span>
                  </div>
                  <el-popover
                    v-else
                    placement="bottom-start"
                    trigger="click"
                    :ref="'popover' + headerIndex"
                  >
                    <div slot="reference" class="search-box">
                      <span class="search-title">{{ headerItem.label }}</span>
                      &nbsp;
                      <i class="search-icon el-icon-search pointer"></i>
                      <i v-if="headerItem.tipContent" class="el-icon-question"></i>
                    </div>
                    <!-- 日期搜索种类在这里添加 -->
                    <!-- 2个日期组件联合查询 -->
                    <!-- 参数 StartAndEnd为true 绑定数据为prop的值+Start和prop的值+End（防止多列数据重复）-->
                    <div
                      class="searchbar allocation_width"
                      v-if="
                        headerItem.StartAndEnd &&
                        headerItem.Datetype.indexOf('range') == -1
                      "
                    >
                      <el-date-picker
                        class="allocation-right left"
                        :type="headerItem.Datetype"
                        placeholder="选择开始日期时间"
                        v-model="headerItem[headerItem.prop + 'Start']"
                      >
                        <!-- style="margin-right: 15px" -->
                      </el-date-picker>
                      <span class="StudentClassAllocation_posi left">至</span>
                      <!-- style="margin-right: -5px" -->
                      <el-date-picker
                        :type="headerItem.Datetype"
                        class="allocation-right left"
                        placeholder="选择结束日期时间"
                        v-model="headerItem[headerItem.prop + 'End']"
                      ></el-date-picker>
                      <span
                        class="searchbar-btn box-icon left"
                        @click="
                          handleSearch(headerIndex, {
                            name: 'datetime',
                            prop: headerItem.prop,
                            value: {
                              start: headerItem[headerItem.prop + 'Start'],
                              end: headerItem[headerItem.prop + 'End'],
                            },
                            row: scope.row,
                            type: 'time',
                            formatSearch: headerItem.formatSearch,
                          })
                        "
                      >
                        <i class="search-icon el-icon-search pointer"></i>
                      </span>
                    </div>
                    <!-- 连表搜索日期 -->
                    <!-- date 、daterange为true 绑定数据和连表搜索日期时间相同-->
                    <div
                      class="searchbar allocation_width"
                      v-else-if="headerItem.daterange"
                    >
                      <el-date-picker
                        class="allocation-right left"
                        :type="headerItem.Datetype"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        range-separator="至"
                        v-model="headerItem[headerItem.prop]"
                        clearable
                      ></el-date-picker>
                      <span
                        class="searchbar-btn box-icon pointer"
                        @click="
                          handleSearch(headerIndex, {
                            name: 'daterange',
                            prop: headerItem.prop,
                            value: headerItem[headerItem.prop],
                            type: 'time',
                            row: scope.row,
                            formatSearch: headerItem.formatSearch,
                          })
                        "
                      >
                        <i class="search-icon el-icon-search pointer"></i>
                      </span>
                    </div>
                    <!-- 日期和时间 -->
                    <div
                      class="searchbar allocation_width"
                      v-else-if="headerItem.dateTime"
                    >
                      <el-date-picker
                        v-model="headerItem[headerItem.prop]"
                        type="datetime"
                        :placeholder="
                          headerItem.placeholder
                            ? headerItem.placeholder
                            : `请选择${headerItem.label}`
                        "
                        :format="
                          headerItem.format != undefined
                            ? headerItem.format
                            : 'yyyy-MM-dd HH:mm:ss'
                        "
                        :value-format="
                          headerItem.valueFormat != undefined
                            ? headerItem.valueFormat
                            : 'yyyy-MM-dd HH:mm:ss'
                        "
                      ></el-date-picker>
                      <span
                        class="searchbar-btn"
                        @click="
                          handleSearch(headerIndex, {
                            name: 'dateTime',
                            prop: headerItem.prop,
                            value: headerItem[headerItem.prop],
                            type: 'dateTime',
                          })
                        "
                      >
                        <i class="search-icon el-icon-search"></i>
                      </span>
                    </div>
                  </el-popover>
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                <slot
                  v-if="headerItem.custom"
                  :name="headerItem.prop + 'custom'"
                  :scope="scope.row"
                  :index="scope.$index"
                ></slot>
                <span
                  v-else
                  :class="{
                    gray:
                      scope.row[headerItem.prop] == null ||
                      scope.row[headerItem.prop] == '' ||
                      scope.row[headerItem.prop] == undefined ||
                      scope.row[headerItem.prop] == '0001-01-01T00:00:00',
                  }"
                >
                  {{
                    scope.row[headerItem.prop] == null ||
                    scope.row[headerItem.prop] == "" ||
                    scope.row[headerItem.prop] == undefined ||
                    scope.row[headerItem.prop] == "0001-01-01T00:00:00"
                      ? headerItem.noSetText
                        ? headerItem.noSetText
                        : "未设置"
                      : datetimeFormat(scope.row[headerItem.prop], headerItem.format)
                  }}
                </span>
              </template>
            </el-table-column>
            <!-- ⑦图片预览 -->
            <el-table-column
              v-else-if="headerItem.img"
              :label="headerItem.label"
              :prop="headerItem.prop"
              :type="headerItem.type"
              :key="'info5-' + headerIndex"
              :width="headerItem.width"
              :align="headerItem.align"
              :fixed="fixedShow ? headerItem.fixed : false"
              :show-overflow-tooltip="true"
            >
              <template slot="header" slot-scope="scope">
                <el-tooltip
                  effect="dark"
                  placement="bottom"
                  class="item"
                  popper-class="mt35"
                  :disabled="!headerItem.tipContent"
                >
                  <div class="content-h" slot="content" v-html="headerItem.content"></div>
                  <el-popover
                    placement="bottom-start"
                    trigger="click"
                    :ref="'popover' + headerIndex"
                  >
                    <div slot="reference" class="search-header">
                      <span class="search-title">{{ headerItem.label }}</span>
                      <i v-if="headerItem.tipContent" class="el-icon-question"></i>
                    </div>
                  </el-popover>
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                <div
                  class="demo-image__preview"
                  v-if="
                    Object.prototype.toString.call(scope.row[headerItem.prop]) ===
                      '[object Array]' && scope.row[headerItem.prop].length > 0
                  "
                >
                  <template v-for="(item, imgIndex) in scope.row[headerItem.prop]">
                    <el-image
                      :key="imgIndex"
                      style="width: 28px; height: 28px"
                      :src="item"
                      :preview-src-list="[item]"
                    ></el-image>
                  </template>
                </div>
                <div
                  v-else-if="
                    scope.row[headerItem.prop] != null && scope.row[headerItem.prop] != ''
                  "
                >
                  <el-image
                    style="width: 28px; height: 28px"
                    :src="scope.row[headerItem.prop]"
                    :preview-src-list="[scope.row[headerItem.prop]]"
                  ></el-image>
                </div>
                <span v-else class="gray">未上传</span>
              </template>
            </el-table-column>
            <!-- ⑧级联查询 -->
            <!-- 使用联级查询 cascader参数为true -->
            <el-table-column
              v-else-if="headerItem.cascader"
              :label="headerItem.label"
              :prop="headerItem.prop"
              :type="headerItem.type"
              :key="'info4-' + headerIndex"
              :width="headerItem.width"
              :align="headerItem.align"
              :fixed="fixedShow ? headerItem.fixed : false"
              :show-overflow-tooltip="true"
            >
              <!-- 表头的 slot -->
              <template slot="header" slot-scope="scope">
                <el-tooltip
                  effect="dark"
                  placement="bottom"
                  class="item"
                  popper-class="mt35"
                  :disabled="!headerItem.tipContent"
                >
                  <div class="content-h" slot="content" v-html="headerItem.content"></div>
                  <div class="searchbar">
                    <el-popover
                      v-if="headerItem.selectAll"
                      placement="bottom-start"
                      width="220"
                      trigger="click"
                      :ref="'popover' + headerIndex"
                    >
                      <div slot="reference" class="search-header">
                        <span class="search-title">{{ headerItem.label }}</span>
                        &nbsp;
                        <i class="search-icon el-icon-search"></i>
                        <!-- <i v-if="headerItem.tipContent" class="el-icon-question"></i> -->
                      </div>
                      <div class="searchbar">
                        <!-- selectOptions为菜单数据 绑定数据为prop的值（防止多列数据重复） -->
                        <!-- 多选 -->
                        <el-cascader
                          :options="headerItem.selectOptions"
                          :filterable="headerItem.selectOptions.length > 9"
                          @change="
                            handleSearch(headerIndex, {
                              name: 'cascader',
                              prop: headerItem.prop,
                              value: headerItem[headerItem.prop],
                              row: scope.row,
                              selectOptions: headerItem.selectOptions,
                              type: 'cascaderAll',
                            })
                          "
                          :ref="'cascaderCategory' + headerIndex"
                          style="width: 100%"
                          :props="{ checkStrictly: true }"
                          v-model="headerItem[headerItem.prop]"
                          :placeholder="headerItem.label"
                          clearable
                        ></el-cascader>
                      </div>
                    </el-popover>
                    <!-- 2024-08-22 yangdan新增级联下拉改对应字段 -->
                    <div v-else-if="headerItem.changeCascader">
                      <el-cascader
                        :options="headerItem.selectOptions"
                        :filterable="headerItem.selectOptions.length > 9"
                        @change="
                          handleSearch(headerIndex, {
                            name: 'cascader',
                            prop: headerItem.prop,
                            value: headerItem[headerItem.prop],
                            row: scope.row,
                            type: 'cascader',
                          })
                        "
                        :ref="'cascaderCategory' + headerIndex"
                        style="width: 100%"
                        :props="{
                          checkStrictly: true,
                          value: 'id',
                          label: 'title',
                          children: 'children',
                        }"
                        v-model="headerItem[headerItem.prop]"
                        :placeholder="headerItem.label"
                        clearable
                      ></el-cascader>
                    </div>
                    <div v-else-if="headerItem.changeCascader1">
                      <el-cascader
                        :options="headerItem.selectOptions"
                        :filterable="headerItem.selectOptions.length > 9"
                        @change="
                          handleSearch(headerIndex, {
                            name: 'cascader',
                            prop: headerItem.prop,
                            value: headerItem[headerItem.prop],
                            row: scope.row,
                            type: 'cascader',
                          })
                        "
                        :ref="'cascaderCategory' + headerIndex"
                        style="width: 100%"
                        :props="{
                          checkStrictly: true,
                          value: 'id',
                          label: 'name',
                          children: 'childModel',
                        }"
                        v-model="headerItem[headerItem.prop]"
                        :placeholder="headerItem.label"
                        clearable
                      ></el-cascader>
                    </div>
                    <div v-else-if="headerItem.changeCascader2">
                      <el-cascader
                        :options="headerItem.selectOptions"
                        :filterable="headerItem.selectOptions.length > 9"
                        @change="
                          handleSearch(headerIndex, {
                            name: 'cascader',
                            prop: headerItem.prop,
                            value: headerItem[headerItem.prop],
                            row: scope.row,
                            type: 'cascader',
                          })
                        "
                        :ref="'cascaderCategory' + headerIndex"
                        style="width: 100%"
                        :props="{
                          checkStrictly: true,
                          value: 'id',
                          label: 'className',
                          children: 'childs',
                        }"
                        v-model="headerItem[headerItem.prop]"
                        :placeholder="headerItem.label"
                        clearable
                      ></el-cascader>
                    </div>
                    <div v-else-if="headerItem.changeCascader3">
                      <el-cascader
                        :options="headerItem.selectOptions"
                        :filterable="headerItem.selectOptions.length > 9"
                        @change="
                          handleSearch(headerIndex, {
                            name: 'cascader',
                            prop: headerItem.prop,
                            value: headerItem[headerItem.prop],
                            row: scope.row,
                            type: 'cascader',
                          })
                        "
                        :ref="'cascaderCategory' + headerIndex"
                        style="width: 100%"
                        :props="{
                          checkStrictly: true,
                          value: 'key',
                          label: 'value',
                          children: 'children',
                        }"
                        v-model="headerItem[headerItem.prop]"
                        :placeholder="headerItem.label"
                        clearable
                      ></el-cascader>
                    </div>
                    <div v-else-if="headerItem.changeCascader4">
                      <el-popover
                      placement="bottom-start"
                      width="220"
                      trigger="click"
                      :ref="'popover' + headerIndex"
                    >
                      <div slot="reference" class="search-header">
                        <span class="search-title">{{ headerItem.label }}</span>
                        &nbsp;
                        <i class="search-icon el-icon-search"></i>
                      </div>
                      <div class="searchbar">
                        <el-cascader
                        :options="headerItem.selectOptions"
                        :filterable="headerItem.selectOptions.length > 9"
                        @change="
                          handleSearch(headerIndex, {
                            name: 'cascader',
                            prop: headerItem.prop,
                            value: headerItem[headerItem.prop],
                            row: scope.row,
                            type: 'cascader',
                          })
                        "
                        :ref="'cascaderCategory' + headerIndex"
                        style="width: 100%"
                        :props="{
                          checkStrictly: true,
                          value: 'id',
                          label: 'title',
                          children: 'children',
                          multiple: true,
                        }"
                        v-model="headerItem[headerItem.prop]"
                        :placeholder="headerItem.label"
                        clearable
                      ></el-cascader>
                      </div>
                    </el-popover>
                      
                    </div>
                    <div v-else>
                      <el-cascader
                        :options="headerItem.selectOptions"
                        :filterable="headerItem.selectOptions.length > 9"
                        @change="
                          handleSearch(headerIndex, {
                            name: 'cascader',
                            prop: headerItem.prop,
                            value: headerItem[headerItem.prop],
                            row: scope.row,
                            type: 'cascader',
                          })
                        "
                        :ref="'cascaderCategory' + headerIndex"
                        style="width: 100%"
                        :props="{ checkStrictly: true }"
                        v-model="headerItem[headerItem.prop]"
                        :placeholder="headerItem.label"
                        clearable
                      ></el-cascader>
                    </div>
                    <i v-if="headerItem.tipContent" class="el-icon-question"></i>
                  </div>
                </el-tooltip>
              </template>
              <!-- 表格的 内容 slot -->
              <template slot-scope="scope">
                <slot
                  v-if="
                    (scope.row[headerItem.imgPath] != 0 ||
                      scope.row[headerItem.imgPath] != null ||
                      scope.row[headerItem.imgPath] != '') &&
                    headerItem.selectImg
                  "
                  :scope="scope.row"
                  name="titleImg"
                ></slot>
                <!-- 没数据提示 -->
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="headerItem.content"
                  placement="right-start"
                  v-if="
                    (scope.row[headerItem.prop] == 0 ||
                      scope.row[headerItem.prop] == null ||
                      scope.row[headerItem.prop] == '') &&
                    headerItem.tooltip
                  "
                >
                  <span class="gray">{{ headerItem.noSetText }}</span>
                </el-tooltip>
                <!-- 没数据，不提示 -->
                <span
                  class="gray"
                  v-else-if="
                    (scope.row[headerItem.prop] == 0 ||
                      scope.row[headerItem.prop] == null ||
                      scope.row[headerItem.prop] == '' ||
                      scope.row[headerItem.prop] == headerItem.noSetText ||
                      scope.row[headerItem.prop] == '请选择') &&
                    headerItem.noTooltip
                  "
                  >{{ headerItem.noSetText }}</span
                >
                <!-- 设置字体颜色 -->
                <span
                  :style="{
                    color:
                      scope.row[headerItem.prop] == headerItem.rowText
                        ? headerItem.color
                        : '',
                  }"
                  v-else-if="
                    (scope.row[headerItem.prop] != 0 ||
                      scope.row[headerItem.prop] != null ||
                      scope.row[headerItem.prop] != '') &&
                    headerItem.isColor
                  "
                  >{{ scope.row[headerItem.prop] }}</span
                >
                <!-- 有数据，提示 -->
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="headerItem.content"
                  placement="right-start"
                  v-else-if="
                    (scope.row[headerItem.prop] != 0 ||
                      scope.row[headerItem.prop] != null ||
                      scope.row[headerItem.prop] != '') &&
                    headerItem.tooltip
                  "
                >
                  <span
                    :style="{
                      color:
                        scope.row[headerItem.prop] == headerItem.rowText
                          ? headerItem.color
                          : '',
                    }"
                    >{{ scope.row[headerItem.prop] }}</span
                  >
                </el-tooltip>
                <!-- 通过id下拉框显示对应的值 -->
                <span
                  :class="{
                    gray:
                      textIds(scope.row[headerItem.prop], headerItem.selectOptions) ===
                      '未设置',
                  }"
                  v-else-if="headerItem.textIds"
                >
                  {{ textIds(scope.row[headerItem.prop], headerItem.selectOptions) }}
                </span>
                <!-- 点击弹窗 -->
                <span
                  class="hand blue"
                  v-else-if="headerItem.table"
                  @click="handleCard(scope.row, headerItem.prop)"
                  type="text"
                  >{{ scope.row[headerItem.prop] }}</span
                >
                <!-- 点击新窗口打开 -->
                <a
                  v-else-if="headerItem.linkUrl"
                  :href="headerItem.linkUrl + scope.row.id"
                  target="_blank"
                  title="点击新窗口跳转"
                  >&nbsp;{{ scope.row[headerItem.prop] }}</a
                >
                <!-- 点击弹窗 -->
                <span
                  class="pointer"
                  @click="clickText(scope.row, headerItem.prop)"
                  v-else-if="headerItem.clickText"
                >
                  {{ scope.row[headerItem.prop] }}
                </span>
                <!-- 自定义插槽 -->
                <slot
                  v-else-if="headerItem.custom"
                  :name="headerItem.prop + 'custom'"
                  :scope="scope.row"
                  :index="scope.$index"
                ></slot>
                <!-- 默认 -->
                <span v-else>{{ scope.row[headerItem.prop] }}</span>
              </template>
            </el-table-column>
            <!-- ⑥自定义未设置+输入框+下拉框 -->
            <el-table-column
              v-else-if="headerItem.noSetOptionsInput"
              :label="headerItem.label"
              :prop="headerItem.prop"
              :type="headerItem.type"
              :key="'info3-' + headerIndex"
              :width="headerItem.width"
              :align="headerItem.align"
              :fixed="fixedShow ? headerItem.fixed : false"
              :show-overflow-tooltip="true"
            >
              <template
                :slot="headerItem.search ? 'header' : ''"
                slot-scope="scope"
                v-if="headerItem.search"
              >
                <el-popover
                  placement="bottom-start"
                  trigger="click"
                  :ref="'popover' + headerIndex"
                >
                  <div slot="reference" class="search-header">
                    <span class="search-title">{{ headerItem.label }}</span>
                    <i class="search-icon el-icon-search"></i>
                    <i v-if="headerItem.tipContent" class="el-icon-question"></i>
                  </div>
                  <div style="width: 420px; display: flex">
                    <el-select
                      style="display: inline-block"
                      v-model="headerItem.searchValue"
                      :placeholder="'请选择' + headerItem.placeholder2"
                      :filterable="headerItem.selectOptions.length > 9 ? true : false"
                      :remote = "headerItem.remoteMethod ? true : false"
                      :filter-method="searchRemote(headerItem)"
                      @focus="searchRemote(headerItem)('')"
                      @change="
                        handleSearch(headerIndex, {
                          name: headerItem.prop + 'Type',
                          value: headerItem.searchValue,
                          type: 'noSetOptions',
                        })
                      "
                    >
                      <el-option
                        v-for="item in headerItem.selectOptions"
                        :key="item.key"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                    <div
                      class="searchbar"
                      style="width: 200px; display: inline-block; margin-left: 10px"
                    >
                      <el-input
                        class="left width-input"
                        v-model="headerItem.searchValue1"
                        :placeholder="
                          headerItem.placeholder
                            ? headerItem.placeholder
                            : '请输入' + headerItem.label
                        "
                        clearable
                        @clear="
                          handleSearch(headerIndex, {
                            name: 'input',
                            prop: headerItem.prop,
                            value: headerItem.searchValue1,
                            row: scope,
                            type: 'text',
                          })
                        "
                      >
                        <i
                          slot="suffix"
                          class="el-input__icon search-icon el-icon-search pointer"
                          @click="
                            handleSearch(headerIndex, {
                              name: 'input',
                              prop: headerItem.prop,
                              value: headerItem.searchValue1,
                              row: scope,
                              type: 'text',
                            })
                          "
                        ></i>
                      </el-input>
                    </div>
                  </div>
                </el-popover>
              </template>
              <template slot-scope="scope">
                <!-- 未设置时的tip提示 -->
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="headerItem.content"
                  placement="right-start"
                  v-if="
                    (scope.row[headerItem.prop] == 0 ||
                      scope.row[headerItem.prop] == null ||
                      scope.row[headerItem.prop] == '') &&
                    headerItem.tooltip
                  "
                >
                  <span :class="redColor ? 'red' : 'gray'">
                    {{ headerItem.noSetText }}
                  </span>
                </el-tooltip>
                <span
                  :class="redColor ? 'red' : 'gray'"
                  v-else-if="
                    (scope.row[headerItem.prop] == 0 ||
                      scope.row[headerItem.prop] == null ||
                      scope.row[headerItem.prop] == '') &&
                    !headerItem.tooltip
                  "
                  >{{ headerItem.noSetText }}</span
                >
                <!-- 点击弹窗 -->
                <span
                  class="hand blue"
                  v-else-if="headerItem.table"
                  @click="handleCard(scope.row, headerItem.prop)"
                  type="text"
                  >{{ scope.row[headerItem.prop] }}</span
                >
                <!-- 自定义插槽 -->
                <slot
                  v-else-if="headerItem.custom"
                  :name="headerItem.prop + 'custom'"
                  :scope="scope.row"
                  :index="scope.$index"
                ></slot>
                <span v-else>{{ scope.row[headerItem.prop] }}</span>
              </template>
            </el-table-column>
            <!-- ⑥自定义未设置+下拉框+下拉框 -->
            <el-table-column
              v-else-if="headerItem.noSetOptionsInput1"
              :label="headerItem.label"
              :prop="headerItem.prop"
              :type="headerItem.type"
              :key="'info3-' + headerIndex"
              :width="headerItem.width"
              :align="headerItem.align"
              :fixed="fixedShow ? headerItem.fixed : false"
              :show-overflow-tooltip="true"
            >
              <template slot="header" slot-scope="scope">
                <el-tooltip
                  effect="dark"
                  placement="bottom"
                  class="item"
                  popper-class="mt35"
                  :disabled="!headerItem.tipContent"
                >
                  <div class="content-h" slot="content" v-html="headerItem.content"></div>
                  <el-popover
                    placement="bottom-start"
                    trigger="click"
                    :ref="'popover' + headerIndex"
                  >
                    <div slot="reference" class="search-header">
                      <span class="search-title">{{ headerItem.label }}</span>
                      <i class="search-icon el-icon-search"></i>
                      <i v-if="headerItem.tipContent" class="el-icon-question"></i>
                    </div>
                    <div>
                      <el-select
                        v-model="headerItem.searchValue"
                        :placeholder="'请选择' + headerItem.placeholder1"
                        :filterable="headerItem.selectOptions.length > 9 ? true : false"
                        :remote = "headerItem.remoteMethod ? true : false"
                        :filter-method="searchRemote(headerItem)"
                        @focus="searchRemote(headerItem)('')"
                        :multiple="headerItem.multiple"
                        @change="
                          handleSearch(headerIndex, {
                            name: 'input',
                            prop: headerItem.prop,
                            value: {
                              select1: headerItem.searchValue,
                              select2: headerItem.searchValue1,
                            },
                            row: scope,
                            type: 'text',
                          })
                        "
                        clearable
                        @clear="
                          handleSearch(headerIndex, {
                            name: 'input',
                            prop: headerItem.prop,
                            value: {
                              select1: headerItem.searchValue,
                              select2: headerItem.searchValue1,
                            },
                            row: scope,
                            type: 'text',
                          })
                        "
                      >
                        <el-option
                          v-for="item in headerItem.selectOptions"
                          :key="item.key"
                          :label="item.value"
                          :value="item.key"
                        ></el-option>
                      </el-select>

                      <el-select
                        v-model="headerItem.searchValue1"
                        :placeholder="'请选择' + headerItem.placeholder2"
                        :filterable="headerItem.selectOptions1.length > 9 ? true : false"
                        :remote = "headerItem.remoteMethod ? true : false"
                        :filter-method="searchRemote(headerItem)"
                        @focus="searchRemote(headerItem)('')"
                        :multiple="headerItem.multiple1"
                        @change="
                          handleSearch(headerIndex, {
                            name: 'input',
                            prop: headerItem.prop,
                            value: {
                              select1: headerItem.searchValue,
                              select2: headerItem.searchValue1,
                            },
                            row: scope,
                            type: 'text',
                          })
                        "
                        clearable
                        @clear="
                          handleSearch(headerIndex, {
                            name: 'input',
                            prop: headerItem.prop,
                            value: {
                              select1: headerItem.searchValue,
                              select2: headerItem.searchValue1,
                            },
                            row: scope,
                            type: 'text',
                          })
                        "
                      >
                        <el-option
                          v-for="item in headerItem.selectOptions1"
                          :key="item.key"
                          :label="item.value"
                          :value="item.key"
                        ></el-option>
                      </el-select>
                    </div>
                  </el-popover>
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                <!-- 自定义插槽 -->
                <slot
                  v-if="headerItem.custom"
                  :name="headerItem.prop + 'custom'"
                  :scope="scope.row"
                  :index="scope.$index"
                >
                </slot>
                <span v-else>{{ scope.row[headerItem.prop] }}</span>
              </template>
            </el-table-column>
            <!-- ④ 操作 -->
            <!-- 使用操作prop值为operation -->
            <el-table-column
              v-else-if="headerItem.caozuo"
              :label="headerItem.label"
              :key="'info2-' + headerIndex"
              :width="headerItem.width"
              :align="headerItem.align"
              :fixed="fixedShow ? headerItem.fixed : false"
              :show-overflow-tooltip="true"
            >
              <!-- 操作按钮插槽 -->
              <!-- <slot></slot> -->
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="primary"
                  plain
                  v-if="headerItem.edit"
                  @click="handleScope(scope.$index, scope.row, 'edit')"
                  >编辑
                </el-button>
                <el-button
                  size="mini"
                  v-if="headerItem.delete"
                  type="danger"
                  plain
                  @click="handleScope(scope.$index, scope.row, 'delete')"
                  >删除
                </el-button>
                <el-button
                  size="mini"
                  v-if="headerItem.view"
                  type="primary"
                  plain
                  @click="handleScope(scope.$index, scope.row, 'view')"
                  >查看
                </el-button>
                <slot
                  v-if="headerItem.custom"
                  :index="scope.$index"
                  :scope="scope.row"
                  name="customButton"
                ></slot>
              </template>
            </el-table-column>
            <!-- 日期格式化 -->
            <el-table-column
              v-else-if="headerItem.timeText"
              :label="headerItem.label"
              :prop="headerItem.prop"
              :type="headerItem.type"
              :key="'info1-' + headerIndex"
              :width="headerItem.width"
              :align="headerItem.align"
              :fixed="fixedShow ? headerItem.fixed : false"
              :show-overflow-tooltip="true"
            >
              <!-- 日期 -->
              <template slot="header" slot-scope="scope">
                <el-tooltip
                  effect="dark"
                  placement="bottom"
                  class="item"
                  popper-class="mt35"
                  :disabled="!headerItem.tipContent"
                >
                  <div class="content-h" slot="content" v-html="headerItem.content"></div>
                  <el-popover
                    placement="bottom-start"
                    trigger="click"
                    :ref="'popover' + headerIndex"
                  >
                    <div slot="reference" class="search-header">
                      <span class="search-title">{{ headerItem.label }}</span>
                      <i class="search-icon el-icon-search"></i>
                      <i v-if="headerItem.tipContent" class="el-icon-question"></i>
                    </div>
                  </el-popover>
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                <span
                  :class="{
                    gray:
                      scope.row[headerItem.prop] == null ||
                      scope.row[headerItem.prop] == '' ||
                      scope.row[headerItem.prop] == undefined ||
                      scope.row[headerItem.prop] == '0001-01-01T00:00:00',
                  }"
                >
                  {{
                    scope.row[headerItem.prop] == null ||
                    scope.row[headerItem.prop] == "" ||
                    scope.row[headerItem.prop] == undefined ||
                    scope.row[headerItem.prop] == "0001-01-01T00:00:00"
                      ? headerItem.noSetText
                        ? headerItem.noSetText
                        : "未设置"
                      : datetimeFormat(scope.row[headerItem.prop], headerItem.format)
                  }}
                </span>
                <slot :name="'custom' + headerItem.prop"></slot>
              </template>
            </el-table-column>
            <!-- 按数目 -->
            <el-table-column
              v-else-if="headerItem.isNumber"
              :label="headerItem.label"
              :prop="headerItem.prop"
              :type="headerItem.type"
              :key="'info1-' + headerIndex"
              :width="headerItem.width"
              :align="headerItem.align"
              :fixed="fixedShow ? headerItem.fixed : false"
              :show-overflow-tooltip="true"
            >
              <template slot="header" slot-scope="scope">
                <el-tooltip
                  effect="dark"
                  placement="bottom"
                  class="item"
                  popper-class="mt35"
                  :disabled="!headerItem.tipContent"
                >
                  <div class="content-h" slot="content" v-html="headerItem.content"></div>
                  <el-popover
                    placement="bottom-start"
                    trigger="click"
                    :ref="'popover' + headerIndex"
                  >
                    <div slot="reference" class="search-header">
                      <span class="search-title">{{ headerItem.label }}</span>
                      &nbsp;
                      <i class="search-icon el-icon-search pointer"></i>
                      <i v-if="headerItem.tipContent" class="el-icon-question"></i>
                    </div>
                    <div
                      class=""
                      style="
                        display: flex;
                        align-items: center;
                        width: 500px;
                        justify-content: center;
                      "
                    >
                      <el-input
                        class="allocation-right left"
                        style="width: 870px; padding-right: 0"
                        v-model="headerItem.searchValue"
                        type="number"
                        :placeholder="`请输入大于或等于xx的${headerItem.label}`"
                        clearable
                      >
                      </el-input>
                      <div
                        class="StudentClassAllocation_posi left"
                        style="display: block; width: 50px"
                      >
                        --
                      </div>
                      <el-input
                        class="allocation-right left"
                        style="width: 870px; padding-right: 0"
                        v-model="headerItem.searchValue1"
                        type="number"
                        :placeholder="`请输入小于或等于xx的${headerItem.label}`"
                        clearable
                      >
                      </el-input>
                      <span
                        class="searchbar-btn box-icon left"
                        @click="
                          numberSearch(
                            headerItem.searchValue,
                            headerItem.searchValue1,
                            {
                              name: 'input',
                              prop: headerItem.prop,
                              value: {
                                select1: headerItem.searchValue,
                                select2: headerItem.searchValue1,
                              },
                              row: scope,
                            },
                            headerItem.label
                          )
                        "
                      >
                        <i class="search-icon el-icon-search pointer"></i>
                      </span>
                    </div>
                  </el-popover>
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                <!-- 自定义插槽 -->
                <slot
                  v-if="headerItem.custom"
                  :name="headerItem.prop + 'custom'"
                  :scope="scope.row"
                  :index="scope.$index"
                >
                </slot>
                <span v-else>{{ scope.row[headerItem.prop] }}<span
                    v-if="
                      headerItem.unit &&
                      (scope.row[headerItem.prop] != 0 ||
                        scope.row[headerItem.prop] != null ||
                        scope.row[headerItem.prop] != '' ||
                        scope.row[headerItem.prop] != headerItem.noSetText ||
                        scope.row[headerItem.prop] != '请选择' ||
                        scope.row[headerItem.prop] != '未设置')
                    "
                    >{{ headerItem.unitText }}</span
                  ></span>
              </template>
            </el-table-column>
            <!-- 按数目2 -->
            <el-table-column
              v-else-if="headerItem.isNumber2"
              :label="headerItem.label"
              :prop="headerItem.prop"
              :type="headerItem.type"
              :key="'info1-' + headerIndex"
              :width="headerItem.width"
              :align="headerItem.align"
              :fixed="fixedShow ? headerItem.fixed : false"
              :show-overflow-tooltip="true"
            >
              <template slot="header" slot-scope="scope">
                <el-tooltip
                  effect="dark"
                  placement="bottom"
                  class="item"
                  popper-class="mt35"
                  :disabled="!headerItem.tipContent"
                >
                  <div class="content-h" slot="content" v-html="headerItem.content"></div>
                  <el-popover
                    placement="bottom-start"
                    trigger="click"
                    :ref="'popover' + headerIndex"
                  >
                    <div slot="reference" class="search-header">
                      <span class="search-title">{{ headerItem.label }}</span>
                      &nbsp;
                      <i class="search-icon el-icon-search pointer"></i>
                      <i v-if="headerItem.tipContent" class="el-icon-question"></i>
                    </div>
                    <div
                      class=""
                      style="
                        display: flex;
                        align-items: center;
                        width: 300px;
                        justify-content: center;
                      "
                    >
                      <el-input
                        class="allocation-right left"
                        style="width: 260px; padding-right: 0"
                        v-model="headerItem.searchValue"
                        type="number"
                        :placeholder="`最低${headerItem.label}`"
                        clearable
                      >
                      </el-input>分
                      <div
                        class="StudentClassAllocation_posi left"
                        style="display: block; width: 30px"
                      >
                        --
                      </div>
                      <el-input
                        class="allocation-right left"
                        style="width: 260px; padding-right: 0"
                        v-model="headerItem.searchValue1"
                        type="number"
                        :placeholder="`最高${headerItem.label}`"
                        clearable
                      >
                      </el-input>分
                      <span
                        class="searchbar-btn box-icon left"
                        @click="
                          numberSearch(
                            headerItem.searchValue,
                            headerItem.searchValue1,
                            {
                              name: 'input',
                              prop: headerItem.prop,
                              value: {
                                select1: headerItem.searchValue,
                                select2: headerItem.searchValue1,
                              },
                              row: scope,
                            },
                            headerItem.label
                          )
                        "
                      >
                        <i class="search-icon el-icon-search pointer"></i>
                      </span>
                    </div>
                  </el-popover>
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                <!-- 自定义插槽 -->
                <slot
                  v-if="headerItem.custom"
                  :name="headerItem.prop + 'custom'"
                  :scope="scope.row"
                  :index="scope.$index"
                >
                </slot>
                <span v-else>{{ scope.row[headerItem.prop] }}<span
                    v-if="
                      headerItem.unit &&
                      (scope.row[headerItem.prop] != 0 ||
                        scope.row[headerItem.prop] != null ||
                        scope.row[headerItem.prop] != '' ||
                        scope.row[headerItem.prop] != headerItem.noSetText ||
                        scope.row[headerItem.prop] != '请选择' ||
                        scope.row[headerItem.prop] != '未设置')
                    "
                    >{{ headerItem.unitText }}</span
                  ></span>
              </template>
            </el-table-column>
            <!-- 分数单独 -->
            <el-table-column
              v-else-if="headerItem.isScore"
              :label="headerItem.label"
              :prop="headerItem.prop"
              :type="headerItem.type"
              :key="'info1-' + headerIndex"
              :width="headerItem.width"
              :align="headerItem.align"
              :fixed="fixedShow ? headerItem.fixed : false"
              :show-overflow-tooltip="true"
            >
              <template slot="header" slot-scope="scope">
                <el-tooltip
                  effect="dark"
                  placement="bottom"
                  class="item"
                  popper-class="mt35"
                  :disabled="!headerItem.tipContent"
                >
                  <div class="content-h" slot="content" v-html="headerItem.content"></div>
                  <el-popover
                    placement="bottom-start"
                    trigger="click"
                    :ref="'popover' + headerIndex"
                  >
                    <div slot="reference" class="search-header">
                      <span class="search-title">{{ headerItem.label }}</span>
                      &nbsp;
                      <i class="search-icon el-icon-search pointer"></i>
                      <i v-if="headerItem.tipContent" class="el-icon-question"></i>
                    </div>
                    <div
                      class=""
                      style="
                        display: flex;
                        align-items: center;
                        width: 480px;
                        justify-content: center;
                      "
                    >
                      <el-input
                        class=""
                        style="width: 250px; padding-right: 0"
                        v-model="headerItem.searchValue"
                        type="number"
                        :placeholder="`请输入大于或等于xx的分数`"
                        clearable
                      >
                      </el-input
                      >分
                      <div
                        class="StudentClassAllocation_posi left"
                        style="display: block; width: 20px"
                      >
                        --
                      </div>
                      <el-input
                        class=""
                        style="width: 250px; padding-right: 0"
                        v-model="headerItem.searchValue1"
                        type="number"
                        :placeholder="`请输入小于或等于xx的分数`"
                        clearable
                      >
                      </el-input
                      >分
                      <span
                        class="searchbar-btn box-icon left"
                        @click="
                          numberSearch(
                            headerItem.searchValue,
                            headerItem.searchValue1,
                            {
                              name: 'input',
                              prop: headerItem.prop,
                              value: {
                                select1: headerItem.searchValue,
                                select2: headerItem.searchValue1,
                              },
                              row: scope,
                            },
                            headerItem.label
                          )
                        "
                      >
                        <i class="search-icon el-icon-search pointer"></i>
                      </span>
                    </div>
                  </el-popover>
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                <!-- 自定义插槽 -->
                <slot
                  v-if="headerItem.custom"
                  :name="headerItem.prop + 'custom'"
                  :scope="scope.row"
                  :index="scope.$index"
                >
                </slot>
                <span v-else>{{ scope.row[headerItem.prop] }}</span>
              </template>
            </el-table-column>
            <!-- 倒计时 -->
            <el-table-column
              v-else-if="headerItem.countDown"
              :label="headerItem.label"
              :prop="headerItem.prop"
              :type="headerItem.type"
              :key="'info0-' + headerIndex"
              :width="headerItem.width"
              :align="headerItem.align"
              :fixed="fixedShow ? headerItem.fixed : false"
              :show-overflow-tooltip="true"
            >
              <!-- 倒计时 -->
              <template slot="header" slot-scope="scope">
                <el-tooltip
                  v-if="headerItem.tipContent"
                  effect="dark"
                  placement="bottom"
                  class="item"
                  :disabled="!headerItem.tipContent"
                >
                  <div
                    class="content-h"
                    slot="content"
                    v-html="headerItem.content"
                  ></div>
                  <el-popover
                    placement="bottom-start"
                    trigger="click"
                    :ref="'popover' + headerIndex"
                  >
                    <span slot="reference" class="search-box">
                      <span class="search-title">{{ headerItem.label }}</span>
                      <i v-if="headerItem.tipContent" class="el-icon-question"></i>
                    </span>
                  </el-popover>
                </el-tooltip>
                <span slot="reference" class="search-box" v-else>
                  <span class="search-title">{{ headerItem.label }}</span>
                </span>
              </template>
              <template slot-scope="scope">
                <span :class="headerItem.redColor ? 'red' : 'gray'">{{
                  countdown(scope.row.lastTime)
                }}</span>
                <slot :name="headerItem.prop"></slot>
              </template>
            </el-table-column>
            <!-- 选择框 -->
            <el-table-column
              v-else-if="headerItem.type == 'selection'"
              :label="headerItem.label"
              :prop="headerItem.prop"
              :type="headerItem.type"
              :key="'info9-' + headerIndex"
              :width="headerItem.width"
              :align="headerItem.align"
              :fixed="fixedShow ? headerItem.fixed : false"
              :show-overflow-tooltip="true"
            ></el-table-column>
            <!-- 排序 -->
            <template v-else-if="headerItem.sortable">
              <el-table-column
                :sortable="headerItem.sortable"
                v-if="!headerItem['hideColumn']"
                :label="headerItem.label"
                :prop="headerItem.prop"
                :type="headerItem.type"
                :key="'info10-' + headerIndex"
                :width="headerItem.width"
                :align="headerItem.align"
                :fixed="fixedShow ? headerItem.fixed : false"
                :show-overflow-tooltip="
                  headerItem.noTooltip === undefined || headerItem.noTooltip === true
                "
              >
                <template slot="header" slot-scope="scope">
                  <el-tooltip
                    v-if="headerItem.tipContent"
                    effect="dark"
                    placement="bottom"
                    class="item"
                    :disabled="!headerItem.tipContent"
                  >
                    <div
                      class="content-h"
                      slot="content"
                      v-html="headerItem.content"
                    ></div>
                    <el-popover
                      placement="bottom-start"
                      trigger="click"
                      :ref="'popover' + headerIndex"
                    >
                      <span slot="reference" class="search-box">
                        <span class="search-title">{{ headerItem.label }}</span>
                        <i v-if="headerItem.tipContent" class="el-icon-question"></i>
                      </span>
                    </el-popover>
                  </el-tooltip>
                  <span slot="reference" class="search-box" v-else>
                    <span class="search-title">{{ headerItem.label }}</span>
                  </span>
                </template>
                <!-- 表格的 内容 slot -->
                <template slot-scope="scope">
                  <!-- 图片 -->
                  <slot
                    v-if="
                      (scope.row[headerItem.imgPath] != 0 ||
                        scope.row[headerItem.imgPath] != null ||
                        scope.row[headerItem.imgPath] != '') &&
                      headerItem.inputImg
                    "
                    :scope="scope.row"
                    name="titleImg"
                  ></slot>
                  <!-- 没数据提示 -->
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="headerItem.content"
                    placement="right-start"
                    v-if="
                      (!scope.row[headerItem.prop] || scope.row[headerItem.prop] == 0) &&
                      headerItem.tooltip
                    "
                  >
                    <span class="gray">{{ headerItem.noSetText }}</span>
                  </el-tooltip>
                  <!-- 没数据，不提示 -->
                  <span
                    class="gray"
                    v-else-if="
                      (scope.row[headerItem.prop] == 0 ||
                        scope.row[headerItem.prop] == null ||
                        scope.row[headerItem.prop] == '' ||
                        scope.row[headerItem.prop] == headerItem.noSetText ||
                        scope.row[headerItem.prop] == '请选择' ||
                        scope.row[headerItem.prop] == '未设置') &&
                      headerItem.noTooltip &&
                      !headerItem.orZero
                    "
                    >{{ headerItem.noSetText }}</span
                  >
                  <!-- 标签样式 -->
                  <span v-else-if="headerItem.isTag">
                    <el-tag
                      size="medium"
                      v-if="
                        scope.row['isSubscribe'] &&
                        scope.row[headerItem.prop] &&
                        scope.row[headerItem.prop] != 0
                      "
                      >已关注</el-tag
                    >
                    <el-tag class="noData" v-else size="medium">未关注</el-tag>
                  </span>
                  <!-- 设置字体颜色 -->
                  <span
                    :style="{
                      color:
                        scope.row[headerItem.prop] == headerItem.rowText
                          ? headerItem.color
                          : '',
                    }"
                    v-else-if="
                      (scope.row[headerItem.prop] != 0 ||
                        scope.row[headerItem.prop] != null ||
                        scope.row[headerItem.prop] != '') &&
                      headerItem.isColor
                    "
                    >{{ scope.row[headerItem.prop] }}</span
                  >
                  <!-- 有数据，提示 -->
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="headerItem.content"
                    placement="right-start"
                    v-else-if="
                      (scope.row[headerItem.prop] != 0 ||
                        scope.row[headerItem.prop] != null ||
                        scope.row[headerItem.prop] != '') &&
                      headerItem.tooltip
                    "
                  >
                    <span
                      :style="{
                        color:
                          scope.row[headerItem.prop] == headerItem.rowText
                            ? headerItem.color
                            : '',
                      }"
                      >{{ scope.row[headerItem.prop] }}</span
                    >
                  </el-tooltip>
                  <!-- 通过id下拉框显示对应的值 -->
                  <span
                    :class="{
                      gray:
                        textIds(
                          scope.row[headerItem.prop],
                          headerItem.selectOptions,
                          'input'
                        ) === '未设置',
                    }"
                    v-else-if="headerItem.textIds"
                  >
                    {{ textIds(scope.row[headerItem.prop], headerItem.selectOptions) }}
                  </span>
                  <!-- 点击弹窗 -->
                  <span
                    class="hand blue"
                    v-else-if="headerItem.table"
                    @click="handleCard(scope.row, headerItem.prop)"
                    type="text"
                    >{{ scope.row[headerItem.prop] }}</span
                  >
                  <!-- 点击新窗口打开 -->
                  <a
                    v-else-if="headerItem.linkUrl"
                    :href="headerItem.linkUrl + scope.row.id"
                    target="_blank"
                    title="点击新窗口跳转"
                    >&nbsp;{{ scope.row[headerItem.prop] }}</a
                  >
                  <!-- 自定义插槽 -->
                  <slot
                    v-else-if="headerItem.custom"
                    :name="headerItem.prop + 'custom'"
                    :scope="scope.row"
                    :index="scope.$index"
                  ></slot>
                  <!-- 默认 -->
                  <span v-else>{{ scope.row[headerItem.prop] }}</span>
                  <span
                    v-if="
                      headerItem.unit &&
                      (scope.row[headerItem.prop] != 0 ||
                        scope.row[headerItem.prop] != null ||
                        scope.row[headerItem.prop] != '' ||
                        scope.row[headerItem.prop] != headerItem.noSetText ||
                        scope.row[headerItem.prop] != '请选择' ||
                        scope.row[headerItem.prop] != '未设置')
                    "
                    >{{ headerItem.unitText }}</span
                  >
                </template>
              </el-table-column>
            </template>
            <template v-else>
              <el-table-column
                v-if="!headerItem['hideColumn']"
                :label="headerItem.label"
                :prop="headerItem.prop"
                :type="headerItem.type"
                :key="'info10-' + headerIndex"
                :width="headerItem.width"
                :align="headerItem.align"
                :fixed="fixedShow ? headerItem.fixed : false"
                :show-overflow-tooltip="
                  headerItem.noTooltip === undefined || headerItem.noTooltip === true
                "
              >
                <template slot="header" slot-scope="scope">
                  <el-tooltip
                    v-if="headerItem.tipContent"
                    effect="dark"
                    placement="bottom"
                    class="item"
                    :disabled="!headerItem.tipContent"
                  >
                    <div
                      class="content-h"
                      slot="content"
                      v-html="headerItem.content"
                    ></div>
                    <el-popover
                      placement="bottom-start"
                      trigger="click"
                      :ref="'popover' + headerIndex"
                    >
                      <div slot="reference" class="search-box">
                        <span class="search-title">{{ headerItem.label }}</span>
                        <i v-if="headerItem.tipContent" class="el-icon-question"></i>
                      </div>
                    </el-popover>
                  </el-tooltip>
                  <slot
                    :name="headerItem.prop + 'Title'"
                    v-else-if="headerItem.slotTitle"
                  ></slot>
                  <div slot="reference" class="search-box" v-else>
                    <span class="search-title">{{ headerItem.label }}</span>
                  </div>
                </template>
                <!-- 表格的 内容 slot -->
                <template slot-scope="scope">
                  <!-- 图片 -->
                  <slot
                    v-if="
                      (scope.row[headerItem.imgPath] != 0 ||
                        scope.row[headerItem.imgPath] != null ||
                        scope.row[headerItem.imgPath] != '') &&
                      headerItem.inputImg
                    "
                    :scope="scope.row"
                    name="titleImg"
                  ></slot>
                  <!-- 没数据提示 -->
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="headerItem.content"
                    placement="right-start"
                    v-if="
                      (!scope.row[headerItem.prop] || scope.row[headerItem.prop] == 0) &&
                      headerItem.tooltip
                    "
                  >
                    <span class="gray">{{ headerItem.noSetText }}</span>
                  </el-tooltip>
                  <!-- 没数据，不提示 -->
                  <span
                    class="gray"
                    v-else-if="
                      (scope.row[headerItem.prop] == 0 ||
                        scope.row[headerItem.prop] == null ||
                        scope.row[headerItem.prop] == '' ||
                        scope.row[headerItem.prop] == headerItem.noSetText ||
                        scope.row[headerItem.prop] == '请选择' ||
                        scope.row[headerItem.prop] == '未设置') &&
                      headerItem.noTooltip &&
                      !headerItem.orZero
                    "
                    >{{ headerItem.noSetText }}</span
                  >
                  <!-- 标签样式 -->
                  <span v-else-if="headerItem.isTag">
                    <el-tag
                      size="medium"
                      v-if="
                        (scope.row['isSubscribe'] || scope.row['isHhSubscribe']) &&
                        scope.row[headerItem.prop] &&
                        scope.row[headerItem.prop] != 0
                      "
                      >已关注</el-tag
                    >
                    <el-tag class="noData" v-else size="medium">未关注</el-tag>
                  </span>
                  <!-- 设置字体颜色 -->
                  <span
                    :style="{
                      color:
                        scope.row[headerItem.prop] == headerItem.rowText
                          ? headerItem.color
                          : '',
                    }"
                    v-else-if="
                      (scope.row[headerItem.prop] != 0 ||
                        scope.row[headerItem.prop] != null ||
                        scope.row[headerItem.prop] != '') &&
                      headerItem.isColor
                    "
                    >{{ scope.row[headerItem.prop] }}</span
                  >
                  <!-- 有数据，提示 -->
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="headerItem.content"
                    placement="right-start"
                    v-else-if="
                      (scope.row[headerItem.prop] != 0 ||
                        scope.row[headerItem.prop] != null ||
                        scope.row[headerItem.prop] != '') &&
                      headerItem.tooltip
                    "
                  >
                    <span
                      :style="{
                        color:
                          scope.row[headerItem.prop] == headerItem.rowText
                            ? headerItem.color
                            : '',
                      }"
                      >{{ scope.row[headerItem.prop] }}</span
                    >
                  </el-tooltip>
                  <!-- 通过id下拉框显示对应的值 -->
                  <span
                    :class="{
                      gray:
                        textIds(
                          scope.row[headerItem.prop],
                          headerItem.selectOptions,
                          'input'
                        ) === '未设置',
                    }"
                    v-else-if="headerItem.textIds"
                  >
                    {{ textIds(scope.row[headerItem.prop], headerItem.selectOptions) }}
                  </span>
                  <!-- 点击弹窗 -->
                  <span
                    class="hand blue"
                    v-else-if="headerItem.table"
                    @click="handleCard(scope.row, headerItem.prop)"
                    type="text"
                    >{{ scope.row[headerItem.prop] }}</span
                  >
                  <!-- 点击新窗口打开 -->
                  <a
                    v-else-if="headerItem.linkUrl"
                    :href="headerItem.linkUrl + scope.row.id"
                    target="_blank"
                    title="点击新窗口跳转"
                    >&nbsp;{{ scope.row[headerItem.prop] }}</a
                  >
                  <!-- 自定义插槽 -->
                  <slot
                    v-else-if="headerItem.custom"
                    :name="headerItem.prop + 'custom'"
                    :scope="scope.row"
                    :index="scope.$index"
                  ></slot>
                  <!-- 默认 -->
                  <span v-else>{{ scope.row[headerItem.prop] }}</span>
                  <span
                    v-if="
                      headerItem.unit &&
                      (scope.row[headerItem.prop] != 0 ||
                        scope.row[headerItem.prop] != null ||
                        scope.row[headerItem.prop] != '' ||
                        scope.row[headerItem.prop] != headerItem.noSetText ||
                        scope.row[headerItem.prop] != '请选择' ||
                        scope.row[headerItem.prop] != '未设置')
                    "
                    >{{ headerItem.unitText }}</span
                  >
                </template>
              </el-table-column>
            </template>
          </template>
        </template>
      </el-table>
    </div>
  </div>
</template>

<script>
import { timeFormatNew, bjDate, isNull, convertCSTtoUTC } from "../common/utils";
import { RecordExport, uploadFile, AppendAdminDataChangeRecord } from "@/network/public";
import FileSaver from "file-saver";
import XLSX from "xlsx";

export default {
  props: {
    emptyText: "",
    loading: {
      type: Boolean,
      default: false,
    },
    loadingText: {
      type: String,
      default: "loading",
    },
    iscountdown: {
      type: Boolean,
      default: false,
    },
    name: "StudentsTableHeader",
    tableMaxHeight: Number,
    tableHeight: Number,
    headerData: Array,
    tableData: Array,
    tableLoading: {
      type: Boolean,
      default: false,
    },
    pagination: Object,
    height: {
      type: Number | String,
      default: 400,
    },
    // treeProps: {
    //   //表格树形结构
    //   type: Object,
    //   default: {
    //     children: "children",
    //   },
    // },
    rowKey: {
      //表格树形结构key值
      type: [String, Function],
      default: "id",
    },
    //导出的Excel名称
    excelName: "",
    //需要导出的表格Table ID
    componentTableId: "",
    redColor: {
      //列表数据
      type: Boolean,
      default: false,
    },
    tableList: {
      //列表数据
      type: Array,
      require: true,
      default: (_) => [],
    },
    hideColumnIndexs: {
      //需要隐藏的列的下标即表格数据的序号从0开始
      type: Array,
      default: (_) => [],
    },
    distributionIsShow: {
      type: Boolean,
      default: true,
    },
    // 单独展示下载
    isShowDown: {
      type: Boolean,
      default: false,
    },
    isEstimateScore: {
      type: Boolean,
      default: false,
    },
    // 控制表格全选显隐
    // 默认true 显示  false 隐藏
    checkboxAll: {
      type: Boolean,
      default: true,
    },
    // 是否合并列
    isSpanMethod: {
      type: Boolean,
      default: false,
    },
    // 是否 展示按钮
    isShowAllBtn: {
      type: Boolean,
      default: true,
    },
    // rowKey: {}, // 嵌套表格
    // widthColumn:{}
  },
  components: {},
  data() {
    return {
      startData: {
        x: 0,
        y: 0, //移动元素事件中鼠标按下的位置
      },
      tooltipVisible: false,
      tooltipText: "",
      scope: [],
      dateTime: null,
      checked: false,
      conKey: false, //避免el-table 表体数据发生变化时，未重新渲染问题
      handleSelection: [],
      isAll: false, //全选参数
      visibleList: [], //显示/隐藏列的选中下标数据集合
      columnList: [], //表格所有列名称数据列表
      curHideList: [],
      headerData_new: [],
      spanTitleArr: [],
      tableKey: 0,
      fixedShow: true,
    };
  },
  watch: {
    tableLoading(value) {},
    tableData(val) {
      this.handleSelectionIn();
      if (this.isSpanMethod) {
        this.getSpanArr(this.tableData);
      }
    },
    headerData: {
      handler(val) {
        this.headerData_new = val;
        this.initData();
      },
      deep: true,
      immediate: true,
    },
    // widthColumn:{
    //   handler(newVal){
    //     // this.widthNum = newVal
    //   },
    //   deep:true,
    //   immediate:true,
    // }
  },
  created() {
    // 即入公海库倒计时定时器
    if (this.iscountdown == true) {
      if (this.tableData) {
        //调用定时器，数据进行处理
        this.countDown = setInterval(() => {
          this.tableData.forEach((row) => {
            // 计算剩余时间戳
            let residue = new Date(row.countdownTime).getTime() - new Date();
            if (residue > 0) {
              // 对每行的剩余时间进行设置
              this.$set(row, "lastTime", residue);
            } else {
              // 倒计时结束，更新列表
              this.$set(row, "lastTime", 0);
            }
          });
        }, 1000);
      } else {
        clearInterval(this.countDown);
      }
    }
    if (this.isSpanMethod) {
      this.getSpanArr(this.tableData);
    }
  },
  destroyed() {
    clearInterval(this.countDown);
  },
  mounted() {
    this.initData();
  },

  methods: {
    // 合并列
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (!this.isSpanMethod) return;
      if (column.label === "报名课程（主）" && this.isSpanMethod) {
        //第1列根据title合并
        const _row = this.spanTitleArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          // [0,0] 表示这一行不显示， [2,1]表示行的合并数
          rowspan: _row,
          colspan: _col,
        };
      }
    },
    getSpanArr(data) {
      let pos;
      this.spanTitleArr = [];
      for (let i = 0; i < data.length; i++) {
        if (i === 0) {
          //如果是第一条记录（索引为0），向数组中加入１，并设置索引位置；
          this.spanTitleArr.push(1);
          pos = 0;
        } else {
          // 判断当前元素与上一个元素的title是否相同
          if (data[i].mainProductId === data[i - 1].mainProductId) {
            this.spanTitleArr[pos] += 1; //将前一位元素＋１，表示合并行数＋１
            this.spanTitleArr.push(0); //向spanTitleArr中添入元素0
          } else {
            this.spanTitleArr.push(1);
            pos = i;
          }
        }
      }
    },
    handleMouseDown(event) {
      try {
        const target = event.target;
        const buttons = this.$el.querySelectorAll(".box1");
        if (
          target === buttons[0] ||
          (event.target.nodeName === "SPAN" &&
            event.target.textContent.trim() === "点击拖动")
        ) {
          this.mousedownHandle(event);
        }
      } catch (e) {
        console.log(e);
      }
    },
    mousedownHandle(event) {
      const bar = this.$refs.configStateBar;
      //获取按下的位置
      const x = event.clientX;
      const y = event.clientY;
      // 记录鼠标按下时位置
      this.startData.x = x;
      this.startData.y = y;
      // 获得鼠标按下时元素的right、bottom值
      var moveElX = bar.offsetLeft;
      var moveElY = bar.offsetTop;
      // 最大边界
      var bodywith = document.body.clientWidth || document.documentElement.clientWidth; //网页可见区域宽(body)
      var bodyheight =
        document.body.clientHeight || document.documentElement.clientHeight; //网页可见区域高(body)
      var moveElWidth = bar.offsetWidth;
      var moveElHeight = bar.offsetHeight;
      var maxDisX = bodywith - moveElWidth;
      var maxDisY = bodyheight - moveElHeight;
      // 鼠标移动：动态修改移动元素的left、top属性
      document.onmousemove = function (event) {
        let nowLeft = event.clientX - x + moveElX;
        let nowTop = event.clientY - y + moveElY;
        if (nowLeft <= 0) {
          nowLeft = 0;
        }
        if (nowLeft >= maxDisX) {
          nowLeft = maxDisX;
        }
        if (nowTop <= 0) {
          nowTop = 0;
        }
        if (nowTop >= maxDisY) {
          nowTop = maxDisY;
        }
        bar.style.left = nowLeft + "px";
        bar.style.top = nowTop + "px";
      };
      document.onmouseup = function (event) {
        document.onmousemove = null;
      };
    },
    // 筛选下拉数据
    selectSearch(val, prop) {
      console.log(val, prop, "筛选下拉数据");
      this.$emit("getBelong", val);
    },
    initData() {
      let _this = this;
      // var curHideList = [];
      _this.columnList = [];
      _this.visibleList = [];
      _this.curHideList = [];
      //页面初始化：动态获取表格有用的所有列生成并放入复选列表并记录初始隐藏列
      this.headerData_new.forEach((obj, index) => {
        if (obj.label) {
          _this.columnList.push({
            label: index,
            value: obj.type == "selection" ? "选择" : obj.label,
          });

          // 记录初始展示的列
          if (_this.hideColumnIndexs.indexOf(index) === -1) {
            _this.visibleList.push(index);
            _this.curHideList[index] = false;
          } else {
            _this.curHideList.push(true);
          }
        }
      });
      // this.handleSelectionIn();
    },
    // 清空
    clearHandle() {
      this.$nextTick(() => {
        this.$refs.multipleTable?.clearSelection();
        this.$emit("clearHandle");
      });
    },
    // 指定列选中
    sonTrueCreatedIntegral(row) {
      this.$nextTick(() => {
        console.log(row, "gouxuan");
        this.$refs.multipleTable?.toggleRowSelection(row);
      });
    },
    // 指定列取消选中
    sonFalseCreatedIntegral(row) {
      this.$nextTick(() => {
        this.$refs.multipleTable?.toggleRowSelection(row, false);
      });
    },
    // 通过id和下拉框的数据显示对应的值
    textIds(row, selectOptions) {
      if (selectOptions.length > 0) {
        let a = selectOptions.filter((item) => {
          if ((item.key || item.key == false) && item.key == row) {
            return item;
          } else if (item.id && item.id == row) {
            return item;
          } else if (item.Id && item.Id == row) {
            return item;
          }
        });
        if (JSON.stringify(a) !== "[]" && a[0].value) {
          return a[0].value;
        } else if (JSON.stringify(a) === "[]") {
          return "未设置";
        } else {
          return a[0].name || a[0].Name;
        }
      }
    },
    // 剩余时间格式化
    countdown(times) {
      if (times > 0) {
        let days = this.addZero(Math.floor(times / 1000 / 60 / 60 / 24));
        let hours = this.addZero(Math.floor((times / 1000 / 60 / 60) % 24));
        let minutes = this.addZero(Math.floor((times / 1000 / 60) % 60));
        let seconds = this.addZero(Math.floor((times / 1000) % 60)); //秒
        return `${days}天${hours}小时${minutes}分${seconds}秒`;
      }
      if (times == 0) {
        return "已掉入公海库";
      } else {
        return "加载中";
      }
    },
    // 个位补零
    addZero(d) {
      return parseInt(d) < 10 ? "0" + d : d;
    },
    handleCard(val, prop) {
      this.$emit("handleCard", val, prop);
    },
    // 点击文字弹框
    clickText(val, prop) {
      this.$emit("handleCard", val, prop);
    },
    datetimeFormat(val, Format) {
      if (!isNull(val) && typeof val == "string" && val.indexOf("T") != -1) {
        if (isNull(Format)) {
          Format = "yyyy-MM-dd hh:mm";
        }
        let a = timeFormatNew(new Date(val), Format);
        return a;
      }
      return val;
    },
    doLayout() {
      this.$refs.multipleTable.doLayout();
    },
    // 操作项
    handleScope(index, row, statu) {
      const rowData = {
        index,
        row,
        statu,
      };
      if (statu == "edit") {
        this.$emit("handleEdit", rowData);
      }
      if (statu == "delete") {
        this.$emit("handleDelete", rowData);
      }
      if (statu == "view") {
        this.$emit("handleView", rowData);
      }
    },
    // 表单初始化默认选中
    handleSelectionIn() {
      this.headerData.map((item) => {
        if (item.type === "selection") {
          if (item.ids && item.ids.length > 0) {
            this.tableData.map((item1) => {
              if (item1.id) {
                if (item.ids.indexOf(item1.id) != -1) {
                  this.$nextTick(() => {
                    this.$refs.multipleTable.toggleRowSelection(item1, true);
                    this.handleSelection.push(item1);
                  });
                }
              } else {
                if (item.ids.indexOf(item1.businessId) != -1) {
                  this.$nextTick(() => {
                    this.$refs.multipleTable.toggleRowSelection(item1, true);
                    this.handleSelection.push(item1);
                  });
                }
              }
            });
          }
          // if ( item.ids.length > 0) {
          //   this.tableData.map((item1) => {
          //     if (item.ids.indexOf(item1.id) != -1) {
          //       this.$nextTick(() => {
          //         this.$refs.multipleTable.toggleRowSelection(item1, true);
          //         this.handleSelection.push(item1);
          //       });
          //     }
          //   });
          // }
        }
      });
    },
    // 全选
    handleSelectionChangeAll(rows) {
      this.$emit("handleSelectionChangeAll", rows);
    },
    // 列表勾选
    handleSelectionChange(rows, row) {
      let selected = rows.length && rows.indexOf(row) !== -1;
      if (selected) {
        // 选中
        let handleSelection = [];
        this.headerData.map((item) => {
          if (item.type === "selection") {
            if (item && item.limit && item.limit.length > 0 && item.limit[0] != 0) {
              if (rows.length >= item.limit[0] && item.limit[0] == 1) {
                if (rows.length != 1) {
                  this.$nextTick(() => {
                    this.$refs.multipleTable.toggleRowSelection(rows[0], false);
                  });
                }
                handleSelection.push(row);
              } else if (
                rows.length > item.limit[0] &&
                item.limit &&
                item.limit[0] != 1
              ) {
                this.$message.warning(`最多只能选择${item.limit[0]}个${item.limit[1]}`);
                this.$refs.multipleTable.toggleRowSelection(row, false);
                let lengthRows;
                rows.map((item, index) => {
                  if (item.id == row.id) {
                    lengthRows = index;
                  }
                });

                handleSelection = rows.splice(index, 1);
              }
            } else if (
              item &&
              item.limit &&
              item.limit.length > 0 &&
              item.limit[0] == 0
            ) {
              handleSelection = rows;
            } else {
              handleSelection.push(row);
            }
          }
        });
        this.handleSelection = handleSelection;
      } else {
        // 取消
        if (this.handleSelection.length > 0) {
          this.handleSelection.map((item, index) => {
            if (item.id == row.id) {
              this.handleSelection.splice(index, 1);
            }
          });
        } else {
          this.handleSelection = [];
        }
      }
      this.$emit("handleSelectionChange", this.handleSelection, row);
    },
    // 列表全选勾选
    handleSelectionChange1(val) {
      this.$emit("handleSelectionChange1", val);
    },
        searchRemote(headerItem) {
      // 远程搜索：返回一个函数，既作为 filter-method 使用，也用于 @focus 触发
      // 如果 headerItem.remoteMethod 为 false，则返回一个空函数，避免模板中调用时出现 "not a function" 错误
      const remoteFn = (keyword = "") => {
        if (!headerItem) return;

        // 如果和上一次搜索的关键字相同，则不再触发
        const lastKeyword = headerItem._lastSearchKeyword;
        if (lastKeyword === keyword) return;

        headerItem._lastSearchKeyword = keyword;
        // 把关键字保存在 headerItem 上（父组件可读取）
        headerItem.value = keyword;
        // 通知父组件去远程搜索，父组件收到后应根据 headerItem.value 请求数据并更新 headerItem.selectOptions
        this.$emit("search-remote", headerItem);
      };

      if (!headerItem || !headerItem.remoteMethod) {
        return () => {};
      }

      return remoteFn;
    },
    // 下拉框搜索
    async handleSearch(index, option) {
      // 时间类的,对时间格式进行处理 范围查询
      if (option.type === "time") {
        if (option.name == "datetime") {
          //"time""date"datetime
          // if (isNull(option.value.start)&&!isNull(option.value.end)) return this.$alert("请选择开始时间");
          if (!isNull(option.value.end)) {
            if (!bjDate(option.value.end, option.value.start)) {
              this.$alert(
                "开始时间不能大于结束时间，结束时间为：" +
                  timeFormatNew(option.value.end, "yyyy-MM-dd hh:mm")
              );
              return;
            }
          }
          if (isNull(option.formatSearch)) {
            option.formatSearch = "yyyy-MM-dd";
          }
          option.value1 = {};
          if (!isNull(option.value.start) && option.value.end != "0001-01-01T00:00:00") {
            option.value1.start = timeFormatNew(option.value.start, option.formatSearch);
          } else {
            option.value1.start = null;
          }
          if (!isNull(option.value.end) && option.value.end != "0001-01-01T00:00:00") {
            option.value1.end = timeFormatNew(option.value.end, option.formatSearch);
          } else {
            option.value1.end = null;
          }
        }

        if (option.name == "daterange") {
          //"time""date"datetime
          if (isNull(option.value)) {
            this.$emit("search-data", option);
            return;
          }
          if (!isNull(option.value[1]) && option.value.end != "0001-01-01T00:00:00") {
            if (!bjDate(option.value[1], option.value[0])) {
              this.$alert(
                "开始时间不能大于结束时间，结束时间为：" +
                  timeFormatNew(option.value[1], "yyyy-MM-dd hh:mm")
              );
              return;
            }
          }
          if (isNull(option.formatSearch)) {
            option.formatSearch = "yyyy-MM-dd";
          }
          option.value1 = [];
          if (!isNull(option.value[0]) && option.value.end != "0001-01-01T00:00:00") {
            option.value1[0] = timeFormatNew(option.value[0], option.formatSearch);
          } else {
            option.value1[0] = null;
          }
          if (!isNull(option.value[1]) && option.value.end != "0001-01-01T00:00:00") {
            option.value1[1] = timeFormatNew(option.value[1], option.formatSearch);
          } else {
            option.value1[1] = null;
          }
        }
        if (option.name == "default") {
          //"time""date"datetime
          // if (isNull(option.value)) return this.$alert("请选择时间");
          if (isNull(option.formatSearch) && option.value != "0001-01-01T00:00:00") {
            option.formatSearch = "yyyy-MM-dd";
          }
          if (option.value) {
            option.value1 = timeFormatNew(option.value, option.formatSearch);
          }
        }
      }
      if (option.type == "cascaderAll") {
        let a = true;
        if (this.isAll) {
          this.isAll = false;
          option.value.map((item) => {
            if (item.indexOf(0) != -1) {
              a = false;
            }
          });
          if (a) {
            this.headerData.map((item) => {
              if (item.selectAll) {
                item.soruceName = [];
                option.value = [];
              }
            });
          }
        } else {
          const list = [];
          option.value.map((item) => {
            if ((item + "").indexOf(0) != -1) {
              (this.isAll = true), this.makeData(list, [], option.selectOptions); // outGoingDepartment就是前面说到的后端返回来的那个list
              this.headerData.map((item) => {
                if (item.selectAll) {
                  item.soruceName = list;
                  option.value = [];
                  option.value.push(...list);
                }
              });
            }
          });
        }
      }
      if (option.type == "selectAll") {
        if (option.value.length == option.source.length) {
          this.checked = true;
        } else {
          this.checked = false;
        }
      }
      // if (option.type == "dateTime") {
      //   option.value = convertCSTtoUTC(option.value);
      // }
      this.$emit("search-data", option);
    },
    sortTable(column, prop, order) {
      this.$emit("sortTable", { column, prop, order });
    },
    // 下拉框选择查询
    numberSearch(val, val2, options, label) {
      if (val && val2) {
        if (val * 1 > val2 * 1) {
          this.$alert(
            "[" +
              label +
              "大于或等于xx数]输入框数目不能大于[" +
              label +
              "小于或等于xx数]输入框数目"
          );
          return;
        }
      }
      this.$emit("search-data", options);
    },
    makeData(list, upArray, dataSource) {
      dataSource.forEach((item) => {
        const array = [...upArray, item.value];
        list.push(array);
        if (item.children) {
          this.makeData(list, array, item.children);
        }
      });
    },
    // 下拉搜索框多选全选
    selectAll(val, index) {
      this.headerData.map((item) => {
        if (item.prop == val) {
          item[item.prop] = [];
          if (this.checked) {
            item.selectOptions.map((item1) => {
              item[item.prop].push(item1.key || item1.id);
            });
            this.handleSearch(index, {
              name: "option",
              prop: val,
              value: item[item.prop],
              source: item.selectOptions,
              row: "",
              type: "select",
            });
          } else {
            item[item.prop] = [];
            this.handleSearch(index, {
              name: "option",
              prop: val,
              value: [],
              source: item.selectOptions,
              row: "",
              type: "select",
            });
          }
        }
      });
      // this.selectedArray = [];
    },
    //刷新表格
    refreshTable() {
      //直接执行父组件中的更新列表方法
      this.$emit("update-list");
    },
    //导出Excel
    downloadExcelMes() {
      this.$confirm("确定要导出页面数据吗?（只能导出当前页的数据）", "确认导出", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.changeRecordExport();
        })
        .catch(() => {
          // 用户点击取消时可以执行的操作
        });
    },
    //检查是否有权限
    async changeRecordExport() {
      const tabObj = sessionStorage.getItem("tabObj")
        ? JSON.parse(sessionStorage.getItem("tabObj"))
        : {};
      let obj = {
        theMenuId: tabObj.name,
        theMenuName: tabObj.title,
        exportCount: this.tableData.length > 0 ? this.tableData.length : 0,
      };
      let res = await RecordExport(obj);
      if (res.code == 1) {
        const recordId = res.result.id;
        let file = await this.downloadExcel();
        let uploadRes = await this.uploadFile(file, this.excelName + ".xlsx");
        const fileSrc = uploadRes.result.fileData.src;
        await this.storeRecord(recordId, fileSrc);
        // this.downloadExcel();
      } else if (res.code != 403) {
        this.$alert(res.message);
      }
    },

    // 存储数据文件
    async storeRecord(recordId, fileSrc) {
      const data = {
        id: recordId,
        filePath: fileSrc,
      };
      console.log(data);
      try {
        const res = await AppendAdminDataChangeRecord(data);
        if (res.code === 1) {
        } else {
          this.$alert("记录存储失败，请重试");
        }
      } catch (error) {
        this.$alert("记录存储失败，请重试");
      }
    },
    // 上传文件到阿里云
    async uploadFile(file, fileName) {
      const formData = new FormData();
      formData.append("file", file, fileName); // 附带文件名

      // 调用上传接口
      const response = await uploadFile(formData);

      return response;
    },
    downloadExcel() {
      if (this.componentTableId == "") this.$message("参数表格ID不能为空,请检查!");
      let talbleId = "#" + this.componentTableId;
      // table要导出的是哪一个表格
      let table = document.querySelector(talbleId).cloneNode(true);
      
      // 获取表头行
      const headerRow = table.querySelector('thead tr');
      if (headerRow) {
        // 清空原有表头
        headerRow.innerHTML = '';
        
        // 从headerData重新构建表头，排除type为selection的列
        this.headerData.forEach((headerItem, index) => {
          if (!this.curHideList[index] && headerItem.label && headerItem.type !== 'selection') {
            const th = document.createElement('th');
            th.textContent = headerItem.label;
            headerRow.appendChild(th);
          }
        });
      }

      // 删除表格内容中的勾选框列
      const rows = table.querySelectorAll('tbody tr');
      rows.forEach(row => {
        const firstCell = row.querySelector('td');
        if (firstCell && firstCell.querySelector('.el-checkbox')) {
          row.removeChild(firstCell);
        }
      });

      var dropdownObj = table.querySelectorAll(
        ".el-select-dropdown,.el-cascader__dropdown"
      );
      var dropdownTable = table.querySelectorAll(".el-popper .el-table");
      //表头是否有下拉框
      dropdownObj.forEach((element) => {
        element.parentNode.removeChild(element);
      });
      dropdownTable.forEach((element) => {
        element.parentNode.removeChild(element);
      });

      // 因为element-ui的表格的fixed属性导致多出一个table，会下载重复内容，这里删除掉
      var fixedObj = table.querySelector(".el-table__fixed");
      if (fixedObj) {
        var fa = fixedObj.parentNode;
        fa.removeChild(fixedObj);
      }
      fixedObj = table.querySelector(".el-table__fixed-left");
      if (fixedObj) {
        fa = fixedObj.parentNode;
        fa.removeChild(fixedObj);
      }
      fixedObj = table.querySelector(".el-table__fixed-right");
      if (fixedObj) {
        fa = fixedObj.parentNode;
        fa.removeChild(fixedObj);
      }

      let wb = XLSX.utils.table_to_book(table, { raw: true }); //获取表格数据
      let etout = XLSX.write(wb, {
        bookType: "xlsx",
        bookSST: true,
        type: "array",
      });
      // 生成 Blob 对象并下载文件
      let blob = new Blob([etout], {
        type: "application/octet-stream",
      });

      try {
        FileSaver.saveAs(blob, this.excelName + ".xlsx"); // 下载文件
      } catch (e) {}

      return blob;
    },
    visibleListChange(item) {
      this.columnList.forEach((obj, index) => {
        this.curHideList[index] = false;
        // 更改显示隐藏列
        if (item.indexOf(index) === -1) {
          this.curHideList[index] = true;
        }
      });
      this.tableKey += 1;
      this.$nextTick(() => {
        const tableContainer = this.$refs.tableContainer;
        if (tableContainer) {
          const tableElement = tableContainer.querySelector("#elTableId");
          if (
            tableElement &&
            !tableElement.classList.contains("el-table--scrollable-x")
          ) {
            this.fixedShow = false;
            // console.log('tableContainer 不存在 el-table--scrollable-x 类名');
          } else {
            this.fixedShow = true;
            // console.log('tableContainer 存在 el-table--scrollable-x 类名');
          }
        }
        // console.log(this.fixedShow,'this.fixedShow')
      });
      // const hiddenArr=[]
      // this.curHideList.map((m,i)=>{
      //   if(m){
      //     hiddenArr.push(i);
      //   }
      // });
      // this.$emit("update-list");
      this.$emit("visible-change", item);
      // this.$emit("getHideColist", hiddenArr);
    },
    // 设置不同审批状态颜色3.26-wdl
    cellStyle({ row, column, rowIndex, columnIndex }) {
      if (row.approvalStateValue === "审批拒绝" && columnIndex === 4) {
        return "color:#f56c6c";
      } else if (row.approvalStateValue === "审批通过" && columnIndex === 4) {
        return "color:#67c23a";
      } else if (row.approvalStateValue === "待审批" && columnIndex === 4) {
        return "color:#e6a23c";
      }

      if (row.statusStr === "审核拒绝" && columnIndex === 6) {
        return "color:#f56c6c";
      } else if (row.statusStr === "审核通过" && columnIndex === 6) {
        return "color:#67c23a";
      } else if (row.statusStr === "待审核" && columnIndex === 6) {
        return "color:#e6a23c";
      }
    },
  },
};
</script>

<style scoped>
.float-r {
  float: right;
  margin-bottom: 5px;
}
.red {
  color: #fd5252;
}

.gray {
  color: #c0c0c0;
}

.box-icon {
  height: 30px;
  width: 30px;
  display: grid;
  /* display: -ms-grid; */
  place-items: center;
  display: -ms-flexbox;
  -ms-flex-pack: center;
  -ms-flex-align: center;
  float: left;
}

.left {
  float: left;
}

.box-icon:hover {
  background-color: #ccc;
  border-radius: 4px;
}

.StudentClassAllocation_posi {
  line-height: 32px;
  margin: 0 5px;
}

.width-input {
  width: 100%;
  position: relative;
}

/deep/ .el-date-editor .el-range-separator {
  padding: 0 14px !important;
}

.searchbar {
  position: relative;
}

.position {
  position: absolute;
  right: 1px;
  width: 32px;
  height: 32px;
}

.el-checkbox {
  text-align: right;
  /* width: 100%; */
  padding-right: 10px;
}

.el-input--suffix >>> .el-input__inner {
  padding-right: 20px;
}

.el-input--suffix >>> .el-input__validateIcon {
  display: none;
}

.el-select >>> .el-input__suffix .el-input__validateIcon {
  display: none;
}

.checkbox {
  border-bottom: 1px solid rgba(245, 245, 245, 0.7);
  padding-bottom: 5px;
  line-height: 20px;
  background-color: #fff;
}

.pointer {
  cursor: pointer;
}

.searchbar >>> .el-input__suffix {
  pointer-events: auto !important;
}

.comTopRight {
  position: absolute;
  top: 9px;
  right: 0px;

  margin-right: 10px;
}

.comActionIcon {
  width: 30px !important;
  height: 30px !important;
  margin: 0 auto;
  font-size: 22px !important;
  border: 1px solid #ccc;
  margin-left: 5px;
  padding-left: 3px;
  padding-top: 3px;
  cursor: pointer;
}

.trends_container {
  position: absolute;
  right: 100px;
  top: 5px;
  /* top: 35px; */
  box-sizing: border-box;
}

.trends_container .trends_oprt_wrap {
  display: inline-block;
  vertical-align: top;
  width: 100px;
}

.trends_container .pagination_wrap {
  display: inline-block;
  vertical-align: top;
  width: calc(100% - 105px);
  margin: 0 !important;
}

.trends_btn_wrap .el-checkbox-group label {
  width: auto;
  margin: 0 !important;
  margin: 0 10px !important;
  margin-bottom: 10px !important;
}

.trends_btn_wrap .table_container .el-table .cell {
  text-overflow: initial !important;
}

.trends_btn_wrap * /deep/ .el-checkbox-group label {
  margin: 0 5px !important;
  margin-bottom: 10px !important;
  margin-right: 0 !important;
}

.el-checkbox.is-bordered.el-checkbox--small {
  padding: 5px 10px 5px 10px;
  border-radius: 3px;
  height: 32px;
  /* width: 110px; */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-bottom: 10px !important;
  margin-right: 0 !important;
}

.el-checkbox.is-bordered.el-checkbox--small .el-checkbox__label {
  /* width: 75px; */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.StudentClassAllocation_posi {
  /* position: absolute; */
  left: 44.5%;
  top: 22%;
}

.searchbar-btn {
  width: 32px;
  height: 35px;
  line-height: 37px;
  text-align: center;
  cursor: pointer;
  margin-right: -4px;
}

.searchbar-btn:hover {
  color: #666;
}

.red {
  color: #fd5252;
}

.el-table__header-wrapper .el-checkbox {
  display: block !important;
}

.el-checkbox-group >>> .el-checkbox {
  text-align: right;
  /* width: 45%; */
  padding-right: 10px;
  margin-bottom: 10px;
}

.tableTemplate /deep/ thead .el-checkbox {
  display: none !important;
}

.searchbar >>> .el-input__clear {
  margin-left: 2px;
  margin-right: -5px;
}

.text-overflow {
  display: inline-block;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  width: 100%;
}

.hover-sty {
  color: #c0c0c0;
  cursor: pointer;
}

.hover-sty:hover {
  color: #409eff;
}

>>> .noData.el-tag {
  border: 1px solid rgba(192, 192, 192, 0.6);
  background-color: rgba(192, 192, 192, 0.1);
  color: #9e9ea2;
}

.content-h {
  height: auto;
  line-height: 26px;
}

>>> .el-tooltip__popper {
  margin-top: 40px;
}

.width160 {
  width: 160px;
}
.floating-buttons {
  width: 92px;
  height: auto;
  position: fixed;
  z-index: 3002;
  right: 40px;
  border-radius: 4px;
  border: 2px solid #dcdfe6;
  border-color: var(--ThemeColor) !important;
}
.el-button {
  margin-bottom: 0px;
  margin-left: 0px !important;
}
.icon-box {
  width: 88px !important;
  height: 40px;
  display: flex;
  color: #666;
  justify-content: center;
  align-items: center;
  border: 1px solid #dcdfe6;
  /* font-size: 20px; */
  cursor: pointer;
  transition: background-color 0.3s;
}
icon-box1 {
  border-radius: 0px !important;
}
.icon-box:hover {
  background-color: #ecf5ff;
  color: #53a8ff;
  border-color: #b9d7f5;
}
.box1 {
  width: 88px;
  height: 40px;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  border-radius: 4px;
}

.tooltip {
  position: absolute;
  top: 30px;
  left: 50%;
  transform: translateX(-50%);
  padding: 5px;
  background-color: #000;
  color: #fff;
  font-size: 12px;
  border-radius: 3px;
  opacity: 0.8;
}
.icon1 {
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}
.icon2,
.icon3 {
  border-radius: 0 !important;
}
.icon4 {
  border-top-left-radius: 0px !important;
  border-top-right-radius: 0px !important;
}
.el-cascader-panel {
  z-index: 10000; /* 确保下拉框在最上层 */
}
.table_box {
  display: flex;
}
.el_table {
  width: auto !important;

  /* flex: 1; */
  /* width:400px !important; */
}
.search-header,
.searchbar {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
